import {
    firebaseConfig,
    auth,
    db,
    functions,
    storage,
    storageRef,
    FirebaseFieldValue,
    FirebaseTimestamp,
    firebaseAuth,
    moment,
} from '../../../config/main_config';
import { downloadFromSDK, convertBlobToBase64 } from '../../downloadFromSDK.module';
import $ from 'jquery';
window.jQuery = window.$ = $;
import * as docx from 'docx';
import { internalAPICall } from '../../internalAPICall.module';
// import { generateDocument } from '../../utils/correctiveActionGenerator.util';
import { getAssignees } from '../../getAssignees.module';
import JSZip from 'jszip';
import XLSXPopulate from "xlsx-populate";
import { XLSXTemplate } from './templates/XLSXTemplate.template';
import Swal from 'sweetalert2';
import { waitForCompanyID } from '../../utils/waitForCompanyID.util';
import { Logo as logoBase64Data } from './templates/Logo.template';
import { generateDocument as generateAssuranceDoc } from '../../utils/assuranceTasksGenerator.util';
import { nameFromUID } from '../../utils/nameFromUID.util';
import { findFrameworkName } from '../../utils/findFrameworkName.util';
import { deiterateAPI } from '../../utils/deiterateAPI.util';
import MCMService from '../../../../../services/mcmService';
import { getEnabledModules } from '../../utils/EnabledModulesManager';

export default class ComplianceProcessor {
    constructor(config) {
        getAssignees().then(() => {
            // Assign config properties to class properties
            this.assignees = window.assignees || [];
            this.logs = config.logs || false;
            this.XlsxPopulate = XLSXPopulate;
            this.docx = docx;
            this.JSZip = JSZip;
            this.base64Excel = XLSXTemplate;
            this.isExportingAuditorPack = true;
            this.complianceCache = {}; // Initialize cache object
            this.selectedFrameworks = [];

            this.getCompanyInformation(window.companyID).then(() => { });
            this.loadComplianceCache().then().catch((error) => console.error(error));

            this.logger = {
                log: (...args) => this.logs && console.log(...args),
                warn: (...args) => this.logs && console.warn(...args),
                error: (...args) => this.logs && console.error(...args),
                info: (...args) => this.logs && console.info(...args),
                debug: (...args) => this.logs && console.debug(...args),
                table: (...args) => this.logs && console.table(...args),
                group: (...args) => this.logs && console.group(...args),
                groupEnd: () => this.logs && console.groupEnd(),
                trace: (...args) => this.logs && console.trace(...args),
            };
        }).catch((error) => {
            throw error;
        })

    }

    async getCompanyInformation(companyID) {
        let companyRef = db.collection('customers').doc(companyID);
        let doc = await companyRef.get();

        if (doc.exists) {
            let companyData = doc.data();

            this.friendlyName = companyData.customerFriendlyName;
            this.tenancyName = companyData.customerFriendlyName;
            this.legalName = companyData.customerName;

            console.log('All properties', this)
        }
    }

    async getUserDisplayName(userID) {
        let foundUser = false;
        for (let i = 0; i < this.assignees.length; i++) {
            if (this.assignees[i]?.userID === userID) {
                return this.assignees[i].firstName + ' ' + this.assignees[i].lastName;
            }
        }

        if (!foundUser) {
            return userID;
        }
    }

    extractRootNumber(controlID) {
        // Implement the logic to derive the root number from controlID
        // For example, if controlID is "A.5.1", rootNumber would be "5.0"
        const parts = controlID.split('.');
        if (parts.length >= 2) {
            return `${parts[1]}.0`; // Example logic, adjust as needed
        }
        return controlID; // Fallback to controlID if extraction fails
    }

    async loadComplianceCache() {
        try {
            const complianceCollectionPath = `/compliance/`;
            const complianceCollectionSnapshot = await db.collection(complianceCollectionPath).get();

            if (!complianceCollectionSnapshot.empty) {
                complianceCollectionSnapshot.forEach((complianceDoc) => {
                    // Save each document's data to the cache using the document ID as the key
                    this.complianceCache[complianceDoc.id] = complianceDoc.data();
                });

                console.log(this.complianceCache);
                console.log('Compliance cache populated.');
            }
        } catch (error) {
            console.error('Error loading compliance cache:', error);
        }
    }

    async pullFromGlobalCompliance(control) {
        try {
            const cacheKey = control.controlNumber || control.controlID;

            // Check if the cache already has the data for the control
            const cachedDocId = Object.keys(this.complianceCache).find((docId) => {
                const data = this.complianceCache[docId];
                return data.controlNumber === cacheKey || data.controlID === cacheKey;
            });

            if (cachedDocId) {
                const complianceData = this.complianceCache[cachedDocId];

                // Update control with data from the cache
                control.controlJustification =
                    complianceData.controlJustification || control.controlJustification;
                control.controlFramework = complianceData.controlFramework || control.controlFramework;

                console.log('Returning cached data for:', cacheKey);
                return control;
            }

            // If not found in the cache, load the cache and then try again
            await this.loadComplianceCache();

            // Retry after loading the cache
            const retryCachedDocId = Object.keys(this.complianceCache).find((docId) => {
                const data = this.complianceCache[docId];
                return data.controlNumber === cacheKey || data.controlID === cacheKey;
            });

            if (retryCachedDocId) {
                const complianceData = this.complianceCache[retryCachedDocId];
                control.controlJustification =
                    complianceData.controlJustification || control.controlJustification;
                control.controlFramework = complianceData.controlFramework || control.controlFramework;

                console.log('Returning data from newly populated cache for:', cacheKey);
                return control;
            }

            // No matching control found
            return {};
        } catch (error) {
            console.error(
                `Error pulling from global compliance for control ${control.controlNumber}:`,
                error,
            );
            return {};
        }
    }

    async getSOAVersion(customerID) {
        const soaPath = `/customers/${customerID}/product/policyPackages/ISO27001keyDocuments/ismsSoa`;
        const soaDoc = await db.doc(soaPath).get();
        const defaultVersion = '1.0.1';

        const versionData = soaDoc.data()?.version;
        if (versionData) {
            const latestVersionKey = Object.keys(versionData).pop();
            const latestVersion = versionData[latestVersionKey]?.versionNumber || defaultVersion;

            // Extract the last updated date using FirebaseTimestamp
            const lastUpdatedTimestamp = versionData[latestVersionKey]?.dateUpdated;
            const lastUpdatedDate = lastUpdatedTimestamp ? lastUpdatedTimestamp.toDate().toLocaleDateString() : 'Unknown Date';

            return {
                version: latestVersion,
                majorVersion: parseInt(latestVersion.split('.')[0]),
                lastUpdated: lastUpdatedDate
            };
        }

        return {
            version: defaultVersion,
            majorVersion: parseInt(defaultVersion.split('.')[0]),
            lastUpdated: 'Unknown Date'
        };
    }

    async checkGlobalSOA(controlID) {
        let found = false;
        for (let standard in this.complianceCache) {
            let controls = this.complianceCache[standard]?.Controls
                ? Object.keys(this.complianceCache[standard]?.Controls)
                : Object.keys(this.complianceCache[standard]);

            // console.log('Standard', standard, 'Controls', controls);

            if (controls.includes(controlID)) {
                // Found the controlID within this standard
                found = true;

                // Some standards store controls under a `Controls` object, others at the root.
                const standardObj = this.complianceCache[standard];
                const container = standardObj?.Controls ? standardObj.Controls : standardObj;
                const controlEntry = container?.[controlID];

                if (controlEntry) {
                    // Avoid mutating the cache directly; tag a cloned object with its framework
                    const withFramework = { ...controlEntry, controlFramework: standard };
                    return withFramework;
                } else {
                    // Defensive logging for edge case: key listed but object missing
                    this.logger?.warn?.('[checkGlobalSOA] Key present but object missing', { standard, controlID });
                    return {};
                }
            } else {
                // console.error("Can't find control", controlID, 'in standard', standard);
            }
        }

        if (!found) {
            console.error("Can't find control", controlID, 'in any standard');
            return {};
        }
    }

    async allGlobalSOAControls(standard) {
        console.log('Checking global for standard', standard);

        // Find standard in compliance cache case insensitive
        let standards = Object.keys(this.complianceCache);

        let result = {};

        for (let i = 0; i < standards.length; i++) {
            if (standard === "all") {
                result = { ...result, ...this.complianceCache[standards[i]] };
            } else {
                if (standards[i].toLowerCase() === standard.toLowerCase()) {
                    if (this.complianceCache[standards[i]]?.Controls) {
                        return this.complianceCache[standards[i]]?.Controls || {};
                    } else {
                        return this.complianceCache[standards[i]] || {};
                    }
                }
            }
        }

        return result;
    }

    async parseISOControls(customerID, selectedFrameworks) {
        let result = [];
        const indexMap = {};

        try {
            if (!this.isExportingAuditorPack) return;

            if (!selectedFrameworks || selectedFrameworks.length === 0) {
                console.error('No framework selected. Exiting.');
                return;
            }

            // const selectedFrameworks = confirmSelection;

            this.selectedFrameworks = [];
            for (let i = 0; i < selectedFrameworks.length; i++) {
                this.selectedFrameworks.push(this.standardToAssuranceFrameName(selectedFrameworks[i]));
            }

            console.log('Selected Frameworks:', selectedFrameworks);

            let foundControlIDs = [];

            // Function to process controls and push to result
            const processControls = (controlData, controlID, framework) => {
                const rootNumber = controlData.rootNumber || this.extractRootNumber(controlID);

                let frameworkGroup = result.find((item) => item.framework === framework);
                if (!frameworkGroup) {
                    frameworkGroup = { framework: framework, clauses: [] };
                    result.push(frameworkGroup);
                }

                let clauseGroup = frameworkGroup.clauses.find((item) => item.rootNumber === rootNumber);
                if (!clauseGroup) {
                    clauseGroup = {
                        rootNumber,
                        clause: controlData.clause || controlData.section || 'N/A',
                        controls: []
                    };
                    frameworkGroup.clauses.push(clauseGroup);
                }

                // Check if control already exists in indexMap
                const controlKey = `${framework}_${controlID}`;
                let control = indexMap[controlKey];
                if (!control) {
                    console.log('[AuditorExport] Control not found in indexMap:', controlKey);
                    let controlImplemented = undefined;
                    if (framework === 'ISM') {
                        // Special handling for ISM implementation status
                        if (controlData?.implementationStatus !== undefined) {
                            controlImplemented = controlData.implementationStatus;
                        } else if (controlData?.currentImplementationStatus !== undefined) {
                            controlImplemented = controlData.currentImplementationStatus;
                        }
                        // Convert ISM status to Yes/No format
                        switch (controlImplemented.toLowerCase()) {
                            case 'fully implemented':
                            case 'implemented':
                                controlImplemented = "Yes";
                                break;
                            case 'not implemented':
                            case 'partially implemented':
                            case 'not applicable':
                                controlImplemented = "No";
                                break;
                            default:
                                controlImplemented = "No";
                        }
                    } else {
                        // Existing logic for other frameworks
                        if (controlData?.currentImplementationStatus !== undefined)
                            controlImplemented = controlData?.currentImplementationStatus === false ? "No" : "Yes";
                        if (controlData?.controlApplicable !== undefined)
                            controlImplemented = controlData?.controlApplicable === false ? "No" : "Yes";
                        if (controlData?.implementationStatus !== undefined)
                            switch (controlData.implementationStatus.toLowerCase()) {
                                case 'fully implemented':
                                case 'partially implemented':
                                case 'implemented':
                                    controlImplemented = "Yes";
                                    break;
                                case 'not implemented':
                                case 'not applicable':
                                    controlImplemented = "No";
                                    break;
                                default:
                                    console.log('%cUnknown implementation status:', 'color: red', controlImplemented, controlData, controlData.implementationStatus, controlData.currentImplementationStatus, controlData.controlApplicable);
                                    controlImplemented = controlData.implementationStatus;
                            }
                    }

                    console.log('[AuditorExport] controlData for control', controlID, controlData);

                    control = {
                        controlName: controlData.controlName || controlData.description || `Control ${controlID}`,
                        controlNumber: controlData.controlID || controlID,
                        controlJustification: framework === 'ISM'
                            ? (controlData.implementationDetails || controlData.implementationPlan || 'No implementation details provided')
                            : (controlData.controlJustification || controlData.implementationPlan || controlData.controlDesc || controlData.controlDescription || 'Implementation Plan / Justification not provided'),
                        controlImplemented: controlImplemented,
                        count: controlData.count || 0,
                        tasksCount: 0,
                        policyCount: 0,
                        docsCount: controlData.docsCount || 0,
                        risksCount: controlData.risksCount || 0,
                        policies: [],
                        supportingDocs: controlData.supportingDocs || [],
                        // Add ISM-specific fields
                        implementationStatus: framework === 'ISM' ? controlData.implementationStatus : undefined,
                        implementationPlan: framework === 'ISM' ? controlData.implementationPlan : undefined,
                        implementationDetails: framework === 'ISM' ? controlData.implementationDetails : undefined,
                        controlOwner: framework === 'ISM' ? controlData.controlOwner : undefined,
                    };

                    clauseGroup.controls.push(control);
                    indexMap[controlKey] = control;
                } else {
                    // Control already exists, merge data if necessary
                    control.controlJustification = controlData.controlJustification || control.controlJustification;
                    // Merge other fields as needed
                }
            };

            // Function to extract rootNumber from controlID
            const extractRootNumber = (controlID) => {
                const parts = controlID.split('.');
                return parts.slice(0, parts.length - 1).join('.');
            };

            // Fetch and process customer's SoA controls
            try {
                const rootPath = `/customers/${customerID}/product/policyPackages/ISO27001keyDocuments/ismsSoa`;
                console.error(`Root Path`, rootPath)
                const ismsSoaDoc = await db.doc(rootPath).get();

                if (ismsSoaDoc.exists) {
                    const data = ismsSoaDoc.data();

                    for (const controlID in data) {
                        const controlData = data[controlID];
                        if (typeof controlData !== 'object' || controlID === 'soaHistory' || controlID === 'version') continue;

                        // Get controlFramework from controlData
                        let controlFramework = controlData.controlFramework || controlData.framework || await findFrameworkName(controlID, false, true) || 'Unknown';

                        console.log('Control Framework', controlFramework)

                        // Sanitise framework name because someone changed iso27001annexacontrols to iso27001
                        controlFramework = controlFramework.replace('iso27001', 'iso270012022annexacontrols');

                        if (
                            selectedFrameworks.includes('all') ||
                            selectedFrameworks.includes(controlFramework.toLowerCase().replace(/\s+/g, ''))
                        ) {
                            foundControlIDs.push(controlID);
                            console.log('Processing COntrol', controlID, controlFramework, controlData)
                            processControls(controlData, controlID, controlFramework);
                        } else {
                            let potentialFramework = await findFrameworkName(controlID, false, true);
                            if (selectedFrameworks.includes(potentialFramework)) {
                                foundControlIDs.push(controlID);
                                console.log('Processing COntrol', controlID, controlFramework, controlData)
                                processControls(controlData, controlID, potentialFramework);
                            }
                        }
                    }
                } else {
                    console.log('No ismsSoa document found.');
                }
            } catch (error) {
                throw new Error(`Error fetching ismsSoa document: ${error.message}`);
            }

            // Fetch and process global controls for each selected framework
            for (const framework of selectedFrameworks) {
                const controls = await this.allGlobalSOAControls(framework);
                console.log('Global Controls', controls)
                if (controls) {
                    for (const controlID in controls) {
                        console.log('Global', controlID)
                        // check if already exists
                        if (foundControlIDs.includes(controlID)) {
                            console.log('Control already exists:', controlID);
                            continue;
                        }
                        const controlData = controls[controlID];
                        processControls(controlData, controlID, framework);
                    }
                } else {
                    console.log(`No global controls found for framework: ${framework}`);
                }
            }

            // Fetch policies and process them for the selected frameworks
            const fetchPolicies = async () => {
                try {
                    const policiesPath = `/customers/${customerID}/product/policyPackages/policies/`;
                    const policiesSnapshot = await db.collection(policiesPath).get();

                    if (!policiesSnapshot.empty) {
                        const policyDocs = policiesSnapshot.docs;

                        for (const policyDoc of policyDocs) {
                            const policyData = policyDoc.data();
                            const policyID = policyDoc.id;

                            // Process procRefs first
                            if (policyData.procRef && Array.isArray(policyData.procRef)) {
                                for (const frameworkGroup of result) {
                                    for (const clauseGroup of frameworkGroup.clauses) {
                                        for (const control of clauseGroup.controls) {
                                            if (policyData.procRef.includes(control.controlNumber)) {
                                                // Ensure policySet is initialized
                                                if (!control.policySet) {
                                                    control.policySet = new Set();
                                                }

                                                // Prevent duplicate addition of the same policy
                                                if (!control.policySet.has(policyID)) {
                                                    control.policies.push({
                                                        policyID: policyID,
                                                        policyName: policyData.policy_name || `Policy ${policyID}`,
                                                        referenceCount: 1, // Initialize or calculate as needed
                                                    });
                                                    control.policyCount += 1;
                                                    control.policySet.add(policyID);
                                                } else {
                                                    control.policies.forEach(policy => {
                                                        if (policy.policyID === policyID) {
                                                            policy.referenceCount += 1;
                                                            // control.policyCount += 1;
                                                        }
                                                    })
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            // Now process screens
                            const screensPath = `${policiesPath}${policyID}/screens/`;
                            const screensSnapshot = await db.collection(screensPath).get();
                            if (!screensSnapshot.empty) {
                                const screens = screensSnapshot.docs
                                    .map((screenDoc) => (screenDoc.id.includes('screen') ? screenDoc.data() : undefined))
                                    .filter((screen) => screen !== undefined);

                                screens.forEach((screen) => {
                                    if (!screen?.complianceRef) return;
                                    const complianceRef = screen.complianceRef || {};

                                    for (const frameworkGroup of result) {
                                        for (const clauseGroup of frameworkGroup.clauses) {
                                            for (const control of clauseGroup.controls) {
                                                for (let standardName in complianceRef) {
                                                    let standardData = complianceRef[standardName];
                                                    if (
                                                        standardData?.controlID !== undefined &&
                                                        standardData.controlID.includes(control.controlNumber)
                                                    ) {
                                                        // Ensure policySet is initialized
                                                        if (!control.policySet) {
                                                            control.policySet = new Set();
                                                        }

                                                        // Reference count calculation
                                                        let refCount = 0;
                                                        screens.forEach((screenCheck) => {
                                                            if (
                                                                screenCheck?.complianceRef?.[standardName]?.controlID.includes(
                                                                    control.controlNumber
                                                                )
                                                            ) {
                                                                refCount++;
                                                            }
                                                        });

                                                        // Prevent duplicate addition of the same policy
                                                        if (!control.policySet.has(policyID)) {
                                                            control.policies.push({
                                                                policyID: policyID,
                                                                policyName: policyData.policy_name || `Policy ${policyID}`,
                                                                referenceCount: refCount,
                                                            });
                                                            control.policyCount += 1;
                                                            control.policySet.add(policyID);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    }

                    const otherDocsPath = `/customers/${customerID}/product/policyPackages/ISO27001keyDocuments/otherDocs`;
                    const otherDocsSnapshot = await db.doc(otherDocsPath).get();

                    if (otherDocsSnapshot.exists) {
                        const supportingDocData = otherDocsSnapshot.data().uploaded;

                        for (const docID in supportingDocData) {
                            const doc = supportingDocData[docID];

                            if (doc?.documentType && doc?.documentType === 'Policy') {
                                const procRefs = doc.procRef || [];

                                for (const frameworkGroup of result) {
                                    for (const clauseGroup of frameworkGroup.clauses) {
                                        for (const control of clauseGroup.controls) {
                                            // console.error('Proc Refs for Control ID', control.controlNumber, procRefs.includes(control.controlNumber));
                                            if (procRefs.includes(control.controlNumber)) {
                                                // // console.log('Control', control)
                                                // if (!control.policySet) {
                                                //             control.policySet = new Set();
                                                //         }

                                                // if (typeof control.supportingDocs === 'object') {
                                                //     if (control.supportingDocs.hasOwnProperty('supportingDocID')) {
                                                //         // remove this and convert rest to array instead
                                                //         let oldObject = control.supportingDocs;
                                                //         // delete oldObject.supportingDocsID;
                                                //         let newArray = Object.values(oldObject);
                                                //         control.supportingDocs = newArray;
                                                //     }
                                                // }
                                                // doc.fileName = doc.fileName.replace(/ACME INC/gi, this.tenancyName);
                                                // control.supportingDocs.push(doc.fileName);
                                                // if (!control.docsCount) control.docsCount = 0;
                                                // control.docsCount += 1;

                                                if (!control.policySet) {
                                                    control.policySet = new Set();
                                                }

                                                // Prevent duplicate addition of the same policy
                                                if (!control.policySet.has(doc.docID)) {
                                                    control.policies.push({
                                                        policyID: doc.docID,
                                                        policyName: doc.fileName || `Policy ${doc.docID}`,
                                                        referenceCount: 1, // Initialize or calculate as needed
                                                    });
                                                    control.policyCount += 1;
                                                    control.policySet.add(doc.docID);
                                                } else {
                                                    control.policies.forEach(policy => {
                                                        if (policy.policyID === doc.docID) {
                                                            policy.referenceCount += 1;
                                                            // control.policyCount += 1;
                                                        }
                                                    })
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (error) {
                    throw new Error(`Error fetching policies: ${error.message}`);
                }
            };

            // Fetch assurance tasks for selected frameworks
            const fetchAssuranceTasks = async (customerID, result) => {
                try {
                    const complianceAssurancePath = `/customers/${customerID}/compliance/assurance`;
                    const complianceAssuranceSnapshot = await db.doc(complianceAssurancePath).get();

                    if (complianceAssuranceSnapshot.exists) {
                        const assuranceData = complianceAssuranceSnapshot.data();

                        for (const frameworkGroup of result) {
                            for (const clauseGroup of frameworkGroup.clauses) {
                                for (const control of clauseGroup.controls) {
                                    const controlID = control.controlNumber;
                                    control.tasks = []; // Initialize tasks array

                                    for (const taskID in assuranceData) {
                                        let task = assuranceData[taskID];
                                        const procRefs = [];

                                        if (task.controlID) {
                                            procRefs.push(...task.controlID);
                                        }

                                        if (task.controlIDs) {
                                            procRefs.push(...task.controlIDs);
                                        }

                                        if (task.checkDetail) {
                                            if (task.checkDetail.hasOwnProperty('procRef')) {
                                                procRefs.push(...task.checkDetail.procRef);
                                            }
                                            // if (task.checkDetail.hasOwnProperty('procRef2013')) {
                                            //     procRefs.push(...task.checkDetail.procRef2013);
                                            // }
                                        }

                                        if (procRefs.includes(controlID)) {
                                            // Check if the task already exists in the control's tasks array
                                            let existingTask = control.tasks.find(t => t.taskID === taskID);
                                            if (existingTask) {
                                                existingTask.referenceCount += 1; // Increment reference count
                                            } else {
                                                control.tasks.push({
                                                    taskID: taskID,
                                                    taskName: task.checkDetail.check || `Task ${taskID}`,
                                                    referenceCount: 1 // Initialize reference count
                                                });
                                            }
                                            control.tasksCount += 1;
                                        }
                                    }
                                }

                                // console.log('Extra Controls', extraControlsThatAreSecretlyClauses);
                                // console.log('Extra Controls Type', typeof extraControlsThatAreSecretlyClauses);
                                // for (const control of Object.values(extraControlsThatAreSecretlyClauses)) {
                                //     const controlID = control.controlID;
                                //     control.tasks = []; // Initialize tasks array

                                //     for (const taskID in assuranceData) {
                                //         let task = assuranceData[taskID];
                                //         const procRefs = [];

                                //         if (task.controlID) {
                                //             procRefs.push(...task.controlID);
                                //         }

                                //         if (task.controlIDs) {
                                //             procRefs.push(...task.controlIDs);
                                //         }

                                //         if (task.checkDetail) {
                                //             if (task.checkDetail.hasOwnProperty('procRef')) {
                                //                 procRefs.push(...task.checkDetail.procRef);
                                //             }
                                //             // if (task.checkDetail.hasOwnProperty('procRef2013')) {
                                //             //     procRefs.push(...task.checkDetail.procRef2013);
                                //             // }
                                //         }

                                //         // if (taskID === "CAST-05") {
                                //         //     console.log('[CAST-05] procRefs', procRefs);
                                //         //     console.log('[CAST-05] controlID', controlID);
                                //         //     console.log('[CAST-05] task', task);
                                //         // }

                                //         if (procRefs.includes(controlID)) {
                                //             // Check if the task already exists in the control's tasks array
                                //             let existingTask = control.tasks.find(t => t.taskID === taskID);
                                //             if (existingTask) {
                                //                 existingTask.referenceCount += 1; // Increment reference count
                                //             } else {
                                //                 control.tasks.push({
                                //                     taskID: taskID,
                                //                     taskName: task.checkDetail.check || `Task ${taskID}`,
                                //                     referenceCount: 1 // Initialize reference count
                                //                 });
                                //             }
                                //             control.tasksCount += 1;
                                //         }
                                //     }
                                // }
                            }
                        }
                    }
                } catch (error) {
                    throw new Error(`Error fetching assurance tasks: ${error.message}`);
                }
            };

            // Fetch risks for selected frameworks
            const fetchRisks = async () => {
                try {
                    // Use the internal API endpoint to fetch risks
                    const response = await deiterateAPI.POST(`/deiterateInternalAPI/risks/get/all`, {
                        mode: 'cors',
                        body: JSON.stringify({ companyID: customerID })
                    });

                    if (response && response.risks) {
                        const risks = response.risks;

                        // Create a map of control IDs to their risk counts
                        const controlRiskCounts = new Map();

                        // First pass: count risks per control
                        for (const risk of risks) {
                            if (risk.selectedControls && Array.isArray(risk.selectedControls)) {
                                for (const controlID of risk.selectedControls) {
                                    controlRiskCounts.set(
                                        controlID, 
                                        (controlRiskCounts.get(controlID) || 0) + 1
                                    );
                                }
                            }
                        }

                        // Second pass: update control objects with their risk counts
                        for (const frameworkGroup of result) {
                            for (const clauseGroup of frameworkGroup.clauses) {
                                for (const control of clauseGroup.controls) {
                                    const controlID = control.controlNumber;
                                    if (controlRiskCounts.has(controlID)) {
                                        control.risksCount = controlRiskCounts.get(controlID);
                                    }
                                }
                            }
                        }
                    }
                } catch (error) {
                    console.error('Error fetching risks:', error);
                    throw new Error(`Error fetching risks: ${error.message}`);
                }
            };

            // Fetch supporting documents for selected frameworks
            const fetchSupportingDocs = async () => {
                try {
                    const otherDocsPath = `/customers/${customerID}/product/policyPackages/ISO27001keyDocuments/otherDocs`;
                    const otherDocsSnapshot = await db.doc(otherDocsPath).get();

                    if (otherDocsSnapshot.exists) {
                        const supportingDocData = otherDocsSnapshot.data().uploaded;

                        for (const docID in supportingDocData) {
                            const doc = supportingDocData[docID];
                            const procRefs = doc.procRef || [];

                            for (const frameworkGroup of result) {
                                for (const clauseGroup of frameworkGroup.clauses) {
                                    for (const control of clauseGroup.controls) {
                                        // console.error('Proc Refs for Control ID', control.controlNumber, procRefs.includes(control.controlNumber));
                                        if (procRefs.includes(control.controlNumber)) {
                                            // console.log('Control', control)
                                            if (!control.supportingDocs) control.supportingDocs = [];

                                            if (typeof control.supportingDocs === 'object') {
                                                if (control.supportingDocs.hasOwnProperty('supportingDocID')) {
                                                    // remove this and convert rest to array instead
                                                    let oldObject = control.supportingDocs;
                                                    // delete oldObject.supportingDocsID;
                                                    let newArray = Object.values(oldObject);
                                                    control.supportingDocs = newArray;
                                                }
                                            }
                                            doc.fileName = doc.fileName.replace(/ACME INC/gi, this.tenancyName);
                                            control.supportingDocs.push(doc.fileName);
                                            if (!control.docsCount) control.docsCount = 0;
                                            control.docsCount += 1;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (error) {
                    throw new Error(`Error fetching supporting documents: ${error.message}`);
                }
            };

            // Special handling for ISM framework
            if (this.isISMSelected(selectedFrameworks)) {
                try {
                    // First check customer's ISM controls
                    const ismPath = `/customers/${customerID}/product/policyPackages/ISO27001keyDocuments/ismsSoa/ism`;
                    const ismSnapshot = await db.collection(ismPath).get();

                    if (!ismSnapshot.empty) {
                        for (const doc of ismSnapshot.docs) {
                            const controlData = doc.data();
                            const controlID = doc.id;

                            if (typeof controlData !== 'object') continue;

                            // Process ISM control
                            await processControls(controlData, controlID, 'ISM');
                            foundControlIDs.push(controlID);
                        }
                    }

                    // Then check global ISM controls
                    const globalIsmPath = '/compliance/ism/controls';
                    const globalIsmSnapshot = await db.collection(globalIsmPath).get();

                    if (!globalIsmSnapshot.empty) {
                        for (const doc of globalIsmSnapshot.docs) {
                            const controlData = doc.data();
                            const controlID = doc.id;

                            // Skip if we already have this control from customer's controls
                            if (foundControlIDs.includes(controlID)) continue;

                            if (typeof controlData !== 'object') continue;

                            // Process global ISM control
                            await processControls(controlData, controlID, 'ISM');
                        }
                    }
                } catch (error) {
                    console.error('Error processing ISM controls:', error);
                }
            }

            // Fetch and process additional data
            await fetchPolicies();
            await fetchAssuranceTasks(customerID, result);
            await fetchRisks();
            await fetchSupportingDocs();

            // Sort the result by framework and root number
            result.sort((a, b) => a.framework.localeCompare(b.framework));
            result.forEach((frameworkGroup) => {
                frameworkGroup.clauses.sort((a, b) => a.rootNumber.localeCompare(b.rootNumber));
            });

            result = this.mergeFrameworksAndClauses(result);

            console.log('Parsed JSON:', result);

            return result;
        } catch (error) {
            console.error('Error parsing data:', error);
        }
    }

    mergeFrameworksAndClauses(data) {
        const frameworkMap = {};

        data.forEach((item) => {
            const frameworkKey = item.framework.toLowerCase();

            if (!frameworkMap[frameworkKey]) {
                // If the framework doesn't exist, add it to the map
                frameworkMap[frameworkKey] = {
                    framework: item.framework,
                    clauses: [],
                    clauseMap: {} // Initialize clauseMap within the framework
                };
            } else {
                // Framework already exists, decide which framework name to keep
                const existingFrameworkName = frameworkMap[frameworkKey].framework;
                const existingHasUppercase = /[A-Z]/.test(existingFrameworkName);
                const newHasUppercase = /[A-Z]/.test(item.framework);

                if (newHasUppercase && !existingHasUppercase) {
                    // If new framework name has uppercase letters and existing does not, replace it
                    frameworkMap[frameworkKey].framework = item.framework;
                } else if (newHasUppercase && existingHasUppercase) {
                    // If both have uppercase letters, prioritize the one with more uppercase letters
                    const existingUppercaseCount = existingFrameworkName.replace(/[^A-Z]/g, '').length;
                    const newUppercaseCount = item.framework.replace(/[^A-Z]/g, '').length;

                    if (newUppercaseCount > existingUppercaseCount) {
                        frameworkMap[frameworkKey].framework = item.framework;
                    }
                }
                // If existing has uppercase and new does not, or both have same number of uppercase letters, keep existing
            }

            const frameworkEntry = frameworkMap[frameworkKey];
            const clauseMap = frameworkEntry.clauseMap;

            item.clauses.forEach((clause) => {
                const rootNumberKey = clause.rootNumber.toLowerCase();

                if (!clauseMap[rootNumberKey]) {
                    // If the clause doesn't exist, add it
                    clauseMap[rootNumberKey] = {
                        rootNumber: clause.rootNumber,
                        clause: clause.clause,
                        controls: [...clause.controls]
                    };
                    frameworkEntry.clauses.push(clauseMap[rootNumberKey]);
                } else {
                    // If the clause exists, merge the controls
                    const existingClause = clauseMap[rootNumberKey];
                    existingClause.controls = existingClause.controls.concat(clause.controls);
                }
            });
        });

        // Remove clauseMap before returning
        const mergedFrameworks = Object.values(frameworkMap).map((frameworkEntry) => {
            return {
                framework: frameworkEntry.framework,
                clauses: frameworkEntry.clauses
            };
        });

        // Sort the frameworks, clauses, and controls
        return this.sortFrameworksClausesAndControls(mergedFrameworks);
    }

    sortFrameworksClausesAndControls(frameworks) {
        frameworks.forEach((framework) => {
            // Sort clauses within the framework
            framework.clauses.sort((a, b) => this.compareHierarchicalNumbers(a.rootNumber, b.rootNumber));

            // Sort controls within each clause
            framework.clauses.forEach((clause) => {
                clause.controls.sort((a, b) => this.compareHierarchicalNumbers(a.controlNumber, b.controlNumber));
            });
        });

        return frameworks;
    }

    compareHierarchicalNumbers(aStr, bStr) {
        const aParts = this.normalizeNumberForHierarchy(aStr);
        const bParts = this.normalizeNumberForHierarchy(bStr);

        const length = Math.max(aParts.length, bParts.length);

        for (let i = 0; i < length; i++) {
            const aNum = aParts[i] || 0;
            const bNum = bParts[i] || 0;

            if (aNum !== bNum) {
                return aNum - bNum;
            }
        }
        return 0;
    }

    normalizeNumberForHierarchy(numberString) {
        // Remove letters and split by periods
        const cleanString = numberString.replace(/[a-zA-Z]/g, '');
        const parts = cleanString.split('.').map((part) => parseInt(part, 10));
        return parts.filter((num) => !isNaN(num));
    }

    async getRawClauseData(selectedFrameworks) {
        // /compliance/isoClauses/{standard}/{year}
        const governingBody = "ISO";
        
        // Determine which standards to fetch based on selected frameworks
        const standardsToFetch = [];
        
        if (selectedFrameworks.includes('iso270012022annexacontrols') || selectedFrameworks.includes('ISO27001')) {
            standardsToFetch.push({ standard: 'ISO27001', year: '2022' });
        }
        
        if (selectedFrameworks.includes('iso420012023controls') || selectedFrameworks.includes('ISO42001')) {
            standardsToFetch.push({ standard: 'ISO42001', year: '2023' });
        }
        
        // If no standards selected, default to ISO 27001:2022
        if (standardsToFetch.length === 0) {
            standardsToFetch.push({ standard: 'ISO27001', year: '2022' });
        }
        
        console.log(`[getRawClauseData] Fetching clauses for ${standardsToFetch.length} standard(s):`, standardsToFetch);
        
        // Fetch headers once (shared across all ISO standards)
        const headersRef = db.collection('compliance').doc('isoClauses').collection('clauseHeaders').doc(governingBody);
        const headersData = await headersRef.get();
        const headers = headersData.exists ? headersData.data().headers : [];
        
        // Fetch all standards and merge clauses
        let mergedClauses = {};
        let standardsList = [];
        let yearsList = [];
        
        for (const { standard, year } of standardsToFetch) {
            console.log(`[getRawClauseData] Fetching ${standard} ${year}...`);
            
            const clauseRef = db.collection('compliance').doc('isoClauses').collection(standard).doc(year);
            const clauseData = await clauseRef.get();

            if (!clauseData.exists) {
                console.error(`[getRawClauseData] Clause data not found for ${standard} ${year}`);
                continue;
            }

            const clauses = clauseData.data().clauses || {};
            
            // Merge clauses with standard/year prefix to avoid conflicts
            for (const [clauseId, clauseData] of Object.entries(clauses)) {
                // Add metadata to identify which standard this clause belongs to
                const prefixedClauseId = standardsToFetch.length > 1 ? `${standard}_${clauseId}` : clauseId;
                mergedClauses[prefixedClauseId] = {
                    ...clauseData,
                    _standard: standard,
                    _year: year
                };
            }
            
            standardsList.push(standard);
            yearsList.push(year);
        }

        let response = {
            clauses: mergedClauses,
            standard: standardsList.join(' & '), // e.g., "ISO27001 & ISO42001"
            year: yearsList.join(' & '), // e.g., "2022 & 2023"
            standards: standardsList, // Array of individual standards
            years: yearsList, // Array of individual years
            headers: headers,
        }

        console.log(`[getRawClauseData] Merged ${Object.keys(mergedClauses).length} clauses from ${standardsList.length} standard(s)`, response);

        return response;
    }

    async getClauseData(selectedFrameworks) {
        // We need to loop through clauses and then do something similar to fetchAssuranceTasks but for clauses
        const clauseData = await this.getRawClauseData(selectedFrameworks);
        const clauses = clauseData.clauses;
        const headers = clauseData.headers;
        const standard = clauseData.standard;
        const year = clauseData.year;


        /* === Assurance Task Processing === */
        const assuranceTasks = await this.getAssuranceTasks();

        for (const control of Object.values(clauses)) {
            const controlID = control.controlID;
            control.tasks = []; // Initialize tasks array

            for (const taskID in assuranceTasks) {
                let task = assuranceTasks[taskID];
                const procRefs = [];

                if (task.controlID) {
                    procRefs.push(...task.controlID);
                }

                if (task.controlIDs) {
                    procRefs.push(...task.controlIDs);
                }

                if (task.checkDetail) {
                    if (task.checkDetail.hasOwnProperty('procRef')) {
                        procRefs.push(...task.checkDetail.procRef);
                    }
                }

                if (procRefs.includes(controlID)) {
                    // Check if the task already exists in the control's tasks array
                    let existingTask = control.tasks.find(t => t.taskID === taskID);
                    if (existingTask) {
                        if (existingTask.hasOwnProperty('referenceCount')) {
                            existingTask.referenceCount += 1; // Increment reference count
                        } else {
                            existingTask.referenceCount = 1;
                        }
                    } else {
                        control.tasks.push({
                            taskID: taskID,
                            taskName: task.checkDetail.check || `Task ${taskID}`,
                            referenceCount: 1 // Initialize reference count
                        });
                    }
                    if (control.hasOwnProperty('tasksCount')) {
                        control.tasksCount += 1;
                    } else {
                        control.tasksCount = 1;
                    }
                }
            }
        }

        /* === End Assurance Task Processing === */
        /* === Start Supporting Docs Processing === */

        try {
            const otherDocsPath = `/customers/${window.companyID}/product/policyPackages/ISO27001keyDocuments/otherDocs`;
            const otherDocsSnapshot = await db.doc(otherDocsPath).get();

            if (otherDocsSnapshot.exists) {
                const supportingDocData = otherDocsSnapshot.data().uploaded;
                console.log('[addClausesSheet] Supporting doc data:', supportingDocData);

                for (const docID in supportingDocData) {
                    const doc = supportingDocData[docID];
                    const procRefs = doc.procRef || [];
                    const controlIDs = doc.controlIDs || [];
                    const relatedControls = doc.relatedControls || [];

                    for (const control of Object.values(clauses)) {
                        const controlID = control.controlID;
                        // if (procRefs.includes(control.controlID)) {
                        //     if (!control.supportingDocs) control.supportingDocs = [];
                        //     doc.fileName = doc.fileName.replace(/ACME INC/gi, this.tenancyName);
                        //     control.supportingDocs.push(doc.fileName);
                        //     if (!control.docsCount) control.docsCount = 0;
                        //     control.docsCount += 1;
                        // }

                        if (procRefs.includes(controlID) || controlIDs.includes(controlID) || relatedControls.includes(controlID)) {
                            if (!control.supportingDocs) control.supportingDocs = [];
                            if (typeof control.supportingDocs === 'object') {
                                if (control.supportingDocs.hasOwnProperty('supportingDocID')) {
                                    // remove this and convert rest to array instead
                                    let oldObject = control.supportingDocs;
                                    // delete oldObject.supportingDocsID;
                                    let newArray = Object.values(oldObject);
                                    control.supportingDocs = newArray;
                                }
                            }
                            doc.fileName = doc.fileName.replace(/ACME INC/gi, this.tenancyName);
                            control.supportingDocs.push(doc.fileName);
                            if (!control.docsCount) control.docsCount = 0;
                            control.docsCount += 1;
                        }
                    }
                }
            }
        } catch (error) {
            throw new Error(`Error fetching supporting documents: ${error.message}`);
        }

        /* === End Supporting Docs Processing === */


        return { clauses, headers, standard, year };
    }

    async addClausesSheet(workbook, jsonData) {
        // Remove existing Clauses sheet if present
        let clausesSheet;
        try {
            clausesSheet = workbook.sheet(1) || workbook.sheet('Clauses');
        } catch (e) {
            console.error("Error getting Clauses sheet:", e);
        }

        let currentRow = 8;
        let lastRootNumber = '';

        // Build a rootNumber to clauseGroup map if available
        let clauseGroupMap = {};
        for (const h of jsonData.headers) {
            clauseGroupMap[h.rootNumber] = h.clauseGroup;
        }

        const sortedClauses = Object.values(jsonData.clauses).sort(
            (a, b) => a.controlID.localeCompare(b.controlID, undefined, { numeric: true })
        );


        for (const clause of sortedClauses) {
            const rootNum = clause.controlID.split(".")[0];

            // Insert clause group header if root number changes
            if (rootNum !== lastRootNumber) {
                const groupHeader = `${rootNum} - ${clauseGroupMap[rootNum] || ""}`;
                // clausesSheet.cell(`C${currentRow}`).value(groupHeader);
                const templateCell = clausesSheet.cell("C8");
                const targetCell = clausesSheet.cell(`C${currentRow}`);
                targetCell.value(groupHeader)
                    .style("bold", templateCell.style("bold"))
                    .style("fill", templateCell.style("fill"))
                    .style("fontColor", templateCell.style("fontColor"))
                    .style("horizontalAlignment", templateCell.style("horizontalAlignment"))
                    .style("verticalAlignment", templateCell.style("verticalAlignment"))
                    .style("border", templateCell.style("border"))
                    .style("fontSize", templateCell.style("fontSize"))
                    .style("fontFamily", templateCell.style("fontFamily"));

                ["A", "B"].forEach(col => {
                    const src = clausesSheet.cell(`${col}8`);
                    const dst = clausesSheet.cell(`${col}${currentRow}`);
                    dst.value(src.value())
                        .style("bold", src.style("bold"))
                        .style("fill", src.style("fill"))
                        .style("fontColor", src.style("fontColor"))
                        .style("horizontalAlignment", src.style("horizontalAlignment"))
                        .style("verticalAlignment", src.style("verticalAlignment"))
                        .style("border", src.style("border"))
                        .style("fontSize", src.style("fontSize"))
                        .style("fontFamily", src.style("fontFamily"));
                });
                // Enforce consistent row height for group header
                clausesSheet.row(currentRow).height(clausesSheet.row(9).height());
                lastRootNumber = rootNum;
                currentRow++;
            }

            // Copy A8 and B8 into A${currentRow} and B${currentRow}
            ["A", "B"].forEach(col => {
                const src = clausesSheet.cell(`${col}8`);
                const dst = clausesSheet.cell(`${col}${currentRow}`);
                dst.value(src.value())
                    .style("bold", src.style("bold"))
                    .style("fill", src.style("fill"))
                    .style("fontColor", src.style("fontColor"))
                    .style("horizontalAlignment", src.style("horizontalAlignment"))
                    .style("verticalAlignment", src.style("verticalAlignment"))
                    .style("border", src.style("border"))
                    .style("fontSize", src.style("fontSize"))
                    .style("fontFamily", src.style("fontFamily"));
            });

            console.log('[addClausesSheet] Adding clause:', clause);

            // Insert clause data
            clausesSheet.cell(`C${currentRow}`).value(clause.controlName);
            clausesSheet.cell(`C${currentRow}`).style("fontColor", clausesSheet.cell("C9").style("fontColor"));
            clausesSheet.cell(`C${currentRow}`).style("bold", clausesSheet.cell("C9").style("bold"));
            clausesSheet.cell(`C${currentRow}`).style("horizontalAlignment", clausesSheet.cell("C9").style("horizontalAlignment"));
            clausesSheet.cell(`C${currentRow}`).style("verticalAlignment", clausesSheet.cell("C9").style("verticalAlignment"));
            clausesSheet.cell(`C${currentRow}`).style("border", clausesSheet.cell("C9").style("border"));
            clausesSheet.cell(`C${currentRow}`).style("fontSize", clausesSheet.cell("C9").style("fontSize"));
            clausesSheet.cell(`C${currentRow}`).style("fontFamily", clausesSheet.cell("C9").style("fontFamily"));
            clausesSheet.cell(`D${currentRow}`).value(clause.controlID);
            clausesSheet.cell(`D${currentRow}`).style("fontColor", clausesSheet.cell("D9").style("fontColor"));
            clausesSheet.cell(`D${currentRow}`).style("bold", clausesSheet.cell("D9").style("bold"));
            clausesSheet.cell(`D${currentRow}`).style("horizontalAlignment", clausesSheet.cell("D9").style("horizontalAlignment"));
            clausesSheet.cell(`D${currentRow}`).style("verticalAlignment", clausesSheet.cell("D9").style("verticalAlignment"));
            clausesSheet.cell(`D${currentRow}`).style("border", clausesSheet.cell("D9").style("border"));
            clausesSheet.cell(`D${currentRow}`).style("fontSize", clausesSheet.cell("D9").style("fontSize"));
            clausesSheet.cell(`D${currentRow}`).style("fontFamily", clausesSheet.cell("D9").style("fontFamily"));
            clausesSheet.cell(`E${currentRow}`).value(clause.framework || clause._standard || "ISO27001");
            clausesSheet.cell(`E${currentRow}`).style("fontColor", clausesSheet.cell("E9").style("fontColor"));
            clausesSheet.cell(`E${currentRow}`).style("bold", clausesSheet.cell("E9").style("bold"));
            clausesSheet.cell(`E${currentRow}`).style("horizontalAlignment", clausesSheet.cell("E9").style("horizontalAlignment"));
            clausesSheet.cell(`E${currentRow}`).style("verticalAlignment", clausesSheet.cell("E9").style("verticalAlignment"));
            clausesSheet.cell(`E${currentRow}`).style("border", clausesSheet.cell("E9").style("border"));
            clausesSheet.cell(`E${currentRow}`).style("fontSize", clausesSheet.cell("E9").style("fontSize"));
            clausesSheet.cell(`E${currentRow}`).style("fontFamily", clausesSheet.cell("E9").style("fontFamily"));
            clausesSheet.cell(`F${currentRow}`).value(clause.tasksCount || 0);
            clausesSheet.cell(`F${currentRow}`).style("fontColor", clausesSheet.cell("F9").style("fontColor"));
            clausesSheet.cell(`F${currentRow}`).style("bold", clausesSheet.cell("F9").style("bold"));
            clausesSheet.cell(`F${currentRow}`).style("horizontalAlignment", clausesSheet.cell("F9").style("horizontalAlignment"));
            clausesSheet.cell(`F${currentRow}`).style("verticalAlignment", clausesSheet.cell("F9").style("verticalAlignment"));
            clausesSheet.cell(`F${currentRow}`).style("border", clausesSheet.cell("F9").style("border"));
            clausesSheet.cell(`F${currentRow}`).style("fontSize", clausesSheet.cell("F9").style("fontSize"));
            clausesSheet.cell(`F${currentRow}`).style("fontFamily", clausesSheet.cell("F9").style("fontFamily"));
            clausesSheet.cell(`G${currentRow}`).value(clause.docsCount || 0);
            clausesSheet.cell(`G${currentRow}`).style("fontColor", clausesSheet.cell("G9").style("fontColor"));
            clausesSheet.cell(`G${currentRow}`).style("bold", clausesSheet.cell("G9").style("bold"));
            clausesSheet.cell(`G${currentRow}`).style("horizontalAlignment", clausesSheet.cell("G9").style("horizontalAlignment"));
            clausesSheet.cell(`G${currentRow}`).style("verticalAlignment", clausesSheet.cell("G9").style("verticalAlignment"));
            clausesSheet.cell(`G${currentRow}`).style("border", clausesSheet.cell("G9").style("border"));
            clausesSheet.cell(`G${currentRow}`).style("fontSize", clausesSheet.cell("G9").style("fontSize"));
            clausesSheet.cell(`G${currentRow}`).style("fontFamily", clausesSheet.cell("G9").style("fontFamily"));
            clausesSheet.cell(`H${currentRow}`).value(new this.XlsxPopulate.RichText())
                .value().add((Array.isArray(clause.supportingDocs) ? clause.supportingDocs : [] || []).join("\n"));
            clausesSheet.cell(`H${currentRow}`).style("fontColor", clausesSheet.cell("H9").style("fontColor"));
            clausesSheet.cell(`H${currentRow}`).style("bold", clausesSheet.cell("H9").style("bold"));
            clausesSheet.cell(`H${currentRow}`).style("horizontalAlignment", clausesSheet.cell("H9").style("horizontalAlignment"));
            clausesSheet.cell(`H${currentRow}`).style("verticalAlignment", clausesSheet.cell("H9").style("verticalAlignment"));
            clausesSheet.cell(`H${currentRow}`).style("border", clausesSheet.cell("H9").style("border"));
            clausesSheet.cell(`H${currentRow}`).style("fontSize", clausesSheet.cell("H9").style("fontSize"));
            clausesSheet.cell(`H${currentRow}`).style("fontFamily", clausesSheet.cell("H9").style("fontFamily"));
            // Enforce consistent row height for clause row
            clausesSheet.row(currentRow).height(clausesSheet.row(9).height());
            currentRow++;
        }

        return workbook;
    }

    async addPolicyReferenceSheet(workbook, jsonData) {
        // Create a new sheet named "Policy References"
        const policySheet = workbook.addSheet("Policy References");

        // Set the header row
        policySheet.row(1).height(40);
        policySheet.cell('A1').value(new XLSXPopulate.RichText())
        policySheet.cell('A1').value().add('#ID', {
            "fontColor": "FFFFFF",
            "fontSize": 13,
            "bold": true
        });
        policySheet.cell('A1').style({
            "fill": "404040",
            // "fontColor": "FFFFFF",
            "fontSize": 13,
            // "bold": true
        });

        policySheet.cell('B1').value(new XLSXPopulate.RichText())
        policySheet.cell('B1').value().add('Policy Name', {
            "fontColor": "FFFFFF",
            "fontSize": 13,
            "bold": true
        });
        policySheet.cell('B1').style({
            "fill": "404040",
            // "fontColor": "FFFFFF",
            "fontSize": 13,
            // "bold": true
        });

        policySheet.cell('C1').value(new XLSXPopulate.RichText())
        policySheet.cell('C1').value().add('Times Referenced', {
            "fontColor": "FFFFFF",
            "fontSize": 13,
            "bold": true
        });
        policySheet.cell('C1').style({
            "fill": "404040",
            // "fontColor": "FFFFFF",
            "fontSize": 13,
            // "bold": true
        });

        policySheet.cell('D1').value(new XLSXPopulate.RichText())
        policySheet.cell('D1').value().add('Control IDs', {
            "fontColor": "FFFFFF",
            "fontSize": 13,
            "bold": true
        }); // New column for Control IDs
        policySheet.cell('D1').style({
            "fill": "404040",
            "fontSize": 13,
        });

        let currentRow = 2; // Start from row 2 since row 1 is the header

        const policyMap = {}; // To store the combined counts of each policy

        // Loop through the jsonData and extract policies
        jsonData.forEach((frameworkGroup) => {
            frameworkGroup.clauses.forEach((clauseGroup) => {
                clauseGroup.controls.forEach((control) => {
                    if (Array.isArray(control.policies)) {
                        // Accumulate the reference counts for each policy
                        control.policies.forEach((policy) => {
                            if (!policyMap[policy.policyID]) {
                                policyMap[policy.policyID] = {
                                    policyName: policy.policyName,
                                    totalReferences: 0,
                                    controlIDs: new Set() // To store unique control IDs
                                };
                            }
                            policyMap[policy.policyID].totalReferences += policy.referenceCount;
                            policyMap[policy.policyID].controlIDs.add(control.controlNumber); // Add the control ID
                        });
                    }
                });
            });
        });

        // Get sorted policy IDs
        const sortedPolicyIDs = Object.keys(policyMap).sort();

        // Insert the aggregated and sorted policies and their counts into the sheet
        sortedPolicyIDs.forEach((policyID) => {
            const policyData = policyMap[policyID];
            policySheet.cell(`A${currentRow}`).value(parseInt(policyID.replaceAll('policy_', ''))); // #ID
            policySheet.cell(`B${currentRow}`).value(policyData.policyName); // Policy Name
            policySheet.cell(`C${currentRow}`).value(policyData.totalReferences); // Times Referenced
            policySheet.cell(`D${currentRow}`).value(new this.XlsxPopulate.RichText())
            policySheet.cell(`D${currentRow}`).value().add([...policyData.controlIDs].join("\n")); // Control IDs (as a comma-separated list)
            policySheet.row(currentRow).style({
                "fontSize": 13
            });
            currentRow++;
        });

        const IDColumnMaxLength = policySheet.range(`A1:A${currentRow}`).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length);
        }, 0);

        // For the default font settings in Excel, 1 char -> 1 pt is a pretty good estimate.
        policySheet.column("A").width(IDColumnMaxLength + 4);

        const NameMaxLength = policySheet.range(`B1:B${currentRow}`).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length);
        }, 0);

        // For the default font settings in Excel, 1 char -> 1 pt is a pretty good estimate.
        policySheet.column("B").width(NameMaxLength + 10);

        const RefMaxLength = policySheet.range(`C1:C${currentRow}`).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length);
        }, 0);

        // For the default font settings in Excel, 1 char -> 1 pt is a pretty good estimate.
        policySheet.column("C").width(RefMaxLength + 7.5);

        const ControlIDsMaxLength = policySheet.range(`D1:D${currentRow}`).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length);
        }, 0);

        // For the default font settings in Excel, 1 char -> 1 pt is a pretty good estimate.
        policySheet.column("D").width(ControlIDsMaxLength + 4);

        return workbook;
    }

    async addSupportingDocsReferenceSheet(workbook, jsonData) {
        // Create a new sheet named "Supporting Docs References"
        const docsSheet = workbook.addSheet("Supporting Docs References");

        // Set the header row
        docsSheet.row(1).height(40);

        docsSheet.cell('A1').value(new XLSXPopulate.RichText())
        docsSheet.cell('A1').value().add('#ID', {
            "fontColor": "FFFFFF",
            "fontSize": 13,
            "bold": true
        });
        docsSheet.cell('A1').style({
            "fill": "404040",
            // "fontColor": "FFFFFF",
            "fontSize": 13,
            // "bold": true
        });

        docsSheet.cell('B1').value(new XLSXPopulate.RichText())
        docsSheet.cell('B1').value().add('Supporting Doc Name', {
            "fontColor": "FFFFFF",
            "fontSize": 13,
            "bold": true
        });
        docsSheet.cell('B1').style({
            "fill": "404040",
            // "fontColor": "FFFFFF",
            "fontSize": 13,
            // "bold": true
        });

        docsSheet.cell('C1').value(new XLSXPopulate.RichText())
        docsSheet.cell('C1').value().add('Times Referenced', {
            "fontColor": "FFFFFF",
            "fontSize": 13,
            "bold": true
        });
        docsSheet.cell('C1').style({
            "fill": "404040",
            // "fontColor": "FFFFFF",
            "fontSize": 13,
            // "bold": true
        });

        docsSheet.cell('D1').value(new XLSXPopulate.RichText())
        docsSheet.cell('D1').value().add('Control IDs', {
            "fontColor": "FFFFFF",
            "fontSize": 13,
            "bold": true
        }); // New column for Control IDs
        docsSheet.cell('D1').style({
            "fill": "404040",
            "fontSize": 13,
        });


        let currentRow = 2; // Start from row 2 since row 1 is the header

        const docsMap = {}; // To store the combined counts of each supporting document

        // Loop through the jsonData and extract supporting docs
        jsonData.forEach((frameworkGroup) => {
            frameworkGroup.clauses.forEach((clauseGroup) => {
                clauseGroup.controls.forEach((control) => {
                    if (Array.isArray(control.supportingDocs)) {
                        // Accumulate the reference counts for each supporting doc
                        control.supportingDocs.forEach((docName) => {
                            if (!docsMap[docName]) {
                                docsMap[docName] = {
                                    totalReferences: 0,
                                    controlIDs: new Set() // To store unique control IDs
                                };
                            }
                            docsMap[docName].totalReferences += 1; // Increment reference count
                            docsMap[docName].controlIDs.add(control.controlNumber); // Add the control ID
                        });
                    }
                });
            });
        });

        // Get sorted document names (IDs)
        const sortedDocNames = Object.keys(docsMap).sort();

        // Insert the aggregated and sorted supporting docs and their counts into the sheet
        sortedDocNames.forEach((docName) => {
            const docData = docsMap[docName];
            docsSheet.cell(`A${currentRow}`).value(currentRow - 1); // #ID (auto-incremented)
            docsSheet.cell(`B${currentRow}`).value(docName); // Supporting Doc Name
            docsSheet.cell(`C${currentRow}`).value(docData.totalReferences); // Times Referenced
            docsSheet.cell(`D${currentRow}`).value(new this.XlsxPopulate.RichText())
            docsSheet.cell(`D${currentRow}`).value().add([...docData.controlIDs].join("\n")); // Control IDs (as a comma-separated list)

            docsSheet.row(currentRow).style({
                "fontSize": 13
            });

            docsSheet.row(currentRow).height(40);
            currentRow++;
        });

        const IDColumnMaxLength = docsSheet.range(`A1:A${currentRow}`).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length);
        }, 0);

        // For the default font settings in Excel, 1 char -> 1 pt is a pretty good estimate.
        docsSheet.column("A").width(IDColumnMaxLength + 4);

        const NameMaxLength = docsSheet.range(`B1:B${currentRow}`).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length);
        }, 0);

        // For the default font settings in Excel, 1 char -> 1 pt is a pretty good estimate.
        docsSheet.column("B").width(NameMaxLength + 10);

        const RefMaxLength = docsSheet.range(`C1:C${currentRow}`).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length);
        }, 0);

        // For the default font settings in Excel, 1 char -> 1 pt is a pretty good estimate.
        docsSheet.column("C").width(RefMaxLength + 7.5);

        const ControlIDsMaxLength = docsSheet.range(`D1:D${currentRow}`).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length);
        }, 0);

        // For the default font settings in Excel, 1 char -> 1 pt is a pretty good estimate.
        docsSheet.column("D").width(ControlIDsMaxLength + 4);

        return workbook;
    }

    async addAssuranceTaskReferenceSheet(workbook, jsonData) {
        // Create a new sheet named "Assurance Task References"
        const taskSheet = workbook.addSheet("Assurance Task References");

        // Set the header row
        taskSheet.row(1).height(40);
        taskSheet.cell('A1').value(new XLSXPopulate.RichText())
        taskSheet.cell('A1').value().add('#ID', {
            "fontColor": "FFFFFF",
            "fontSize": 13,
            "bold": true
        });
        taskSheet.cell('A1').style({
            "fill": "404040",
            "fontSize": 13,
        });

        taskSheet.cell('B1').value(new XLSXPopulate.RichText())
        taskSheet.cell('B1').value().add('Task Name', {
            "fontColor": "FFFFFF",
            "fontSize": 13,
            "bold": true
        });
        taskSheet.cell('B1').style({
            "fill": "404040",
            "fontSize": 13,
        });

        taskSheet.cell('C1').value(new XLSXPopulate.RichText())
        taskSheet.cell('C1').value().add('Times Referenced', {
            "fontColor": "FFFFFF",
            "fontSize": 13,
            "bold": true
        });
        taskSheet.cell('C1').style({
            "fill": "404040",
            "fontSize": 13,
        });

        taskSheet.cell('D1').value(new XLSXPopulate.RichText())
        taskSheet.cell('D1').value().add('Control IDs', {
            "fontColor": "FFFFFF",
            "fontSize": 13,
            "bold": true
        });
        taskSheet.cell('D1').style({
            "fill": "404040",
            "fontSize": 13,
        });

        let currentRow = 2; // Start from row 2 since row 1 is the header

        const taskMap = {}; // To store the combined counts of each task

        // Loop through the jsonData and extract tasks
        jsonData.forEach((frameworkGroup) => {
            frameworkGroup.clauses.forEach((clauseGroup) => {
                clauseGroup.controls.forEach((control) => {
                    if (Array.isArray(control.tasks)) {
                        // Accumulate the reference counts for each task
                        control.tasks.forEach((task) => {
                            console.log(`Processing task: ${task.taskID}, ${task.taskName}`); // Debugging log
                            if (!taskMap[task.taskID]) {
                                taskMap[task.taskID] = {
                                    taskName: task.taskName.replace(/acme inc/gi, this.friendlyName),
                                    totalReferences: 0,
                                    controlIDs: new Set() // To store unique control IDs
                                };
                            }
                            taskMap[task.taskID].totalReferences += task.referenceCount;
                            taskMap[task.taskID].controlIDs.add(control.controlNumber); // Add the control ID
                        });
                    } else {
                        console.warn(`No tasks found for control: ${control.controlNumber}`); // Debugging log
                    }
                });
            });
        });

        // Get sorted task IDs
        const sortedTaskIDs = Object.keys(taskMap).sort();

        // Insert the aggregated and sorted tasks and their counts into the sheet
        sortedTaskIDs.forEach((taskID) => {
            const taskData = taskMap[taskID];
            taskSheet.cell(`A${currentRow}`).value(taskID); // #ID
            taskSheet.cell(`B${currentRow}`).value(taskData.taskName.replace(/acme inc/gi, this.friendlyName)); // Task Name
            taskSheet.cell(`C${currentRow}`).value(taskData.totalReferences); // Times Referenced
            taskSheet.cell(`D${currentRow}`).value(new this.XlsxPopulate.RichText())
            taskSheet.cell(`D${currentRow}`).value().add([...taskData.controlIDs].join("\n")); // Control IDs (as a comma-separated list)
            taskSheet.row(currentRow).style({
                "fontSize": 13
            });
            currentRow++;
        });

        const IDColumnMaxLength = taskSheet.range(`A1:A${currentRow}`).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length);
        }, 0);

        taskSheet.column("A").width(IDColumnMaxLength + 4);

        const NameMaxLength = taskSheet.range(`B1:B${currentRow}`).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length);
        }, 0);

        taskSheet.column("B").width(NameMaxLength + 10);

        const RefMaxLength = taskSheet.range(`C1:C${currentRow}`).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length);
        }, 0);

        taskSheet.column("C").width(RefMaxLength + 7.5);

        const ControlIDsMaxLength = taskSheet.range(`D1:D${currentRow}`).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length);
        }, 0);

        taskSheet.column("D").width(ControlIDsMaxLength + 4);

        return workbook;
    }

    async addMasterControlMappingSheet(workbook, jsonData) {
        // Create a new sheet named "Master Control Mapping"
        const mcmSheet = workbook.addSheet("Master Control Mapping");

        // Header styling similar to other sheets
        mcmSheet.row(1).height(40);
        const headers = [
            'Standard',
            'Control ID',
            'Control Name',
            'Link Domain',
            'Relation',
            'Link ID',
            'Link Title',
            'Link Scheme',
            'Confidence'
        ];
        const headerCols = ['A','B','C','D','E','F','G','H','I'];
        headers.forEach((h, idx) => {
            const cellRef = `${headerCols[idx]}1`;
            mcmSheet.cell(cellRef).value(new this.XlsxPopulate.RichText());
            mcmSheet.cell(cellRef).value().add(h, { fontColor: 'FFFFFF', fontSize: 13, bold: true });
            mcmSheet.cell(cellRef).style({ fill: '404040' });
        });

        // Flatten controls from jsonData (result of parseISOControls)
        const seen = new Set();
        const controls = [];
        const standardNameFor = async (framework) => await this.cleanStandardName(framework) || framework;

        for (const item of (jsonData || [])) {
            const std = await standardNameFor(item.framework);
            for (const clause of (item.clauses || [])) {
                for (const control of (clause.controls || [])) {
                    const cid = String(control.controlNumber || control.controlID || '').trim();
                    if (!cid) continue;
                    const key = `${std}::${cid}`;
                    if (seen.has(key)) continue;
                    seen.add(key);
                    controls.push({ standard: std, controlID: cid, controlName: control.controlName || '' });
                }
            }
        }

        // Populate rows: one row per linked component (or one blank if none). Only show Standard/Control columns on first row per control
        let row = 2;
        for (const c of controls) {
            try {
                const mcmCtrl = await MCMService.getControlById(c.controlID, window.companyID);
                const links = Array.isArray(mcmCtrl?.linkedComponents) ? mcmCtrl.linkedComponents : [];
                if (!links.length) {
                    // Single row (no links)
                    mcmSheet.cell(`A${row}`).value(c.standard || '');
                    mcmSheet.cell(`B${row}`).value(c.controlID || '');
                    mcmSheet.cell(`C${row}`).value(mcmCtrl?.controlName || c.controlName || '');
                    row++;
                    continue;
                }
                let isFirst = true;
                for (const link of links) {
                    if (isFirst) {
                        mcmSheet.cell(`A${row}`).value(c.standard || '');
                        mcmSheet.cell(`B${row}`).value(c.controlID || '');
                        mcmSheet.cell(`C${row}`).value(mcmCtrl?.controlName || c.controlName || '');
                        isFirst = false;
                    }
                    mcmSheet.cell(`D${row}`).value(link.domain || '');
                    mcmSheet.cell(`E${row}`).value(link.relation || (link.domain ? MCMService.getRelationForDomain(link.domain) : ''));
                    mcmSheet.cell(`F${row}`).value(link.ref || link.id || '');
                    mcmSheet.cell(`G${row}`).value(link.title || '');
                    mcmSheet.cell(`H${row}`).value(link.scheme || '');
                    mcmSheet.cell(`I${row}`).value(typeof link.confidence === 'number' ? link.confidence : '');
                    row++;
                }
            } catch (e) {
                // Minimal row if lookup fails
                mcmSheet.cell(`A${row}`).value(c.standard || '');
                mcmSheet.cell(`B${row}`).value(c.controlID || '');
                mcmSheet.cell(`C${row}`).value(c.controlName || '');
                row++;
            }
        }

        // Auto width for columns based on header + content length heuristic
        const colMax = new Array(headerCols.length).fill(0);
        for (let r = 1; r < row; r++) {
            headerCols.forEach((col, idx) => {
                const val = String(mcmSheet.cell(`${col}${r}`).value() ?? '');
                colMax[idx] = Math.max(colMax[idx], val.length);
            });
        }
        headerCols.forEach((col, idx) => mcmSheet.column(col).width(Math.min(60, Math.max(12, colMax[idx] + 4))));

        return workbook;
    }
    base64ToArrayBuffer(base64) {
        const binaryString = atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }

    cleanStandardName(standard) {
        if (!standard) return '';

        standard = standard.toLowerCase();
        const standardMap = {
            dispcontrols: "DISP",
            e8controls: "Essential 8",
            "iso 27701": "ISO 27701",
            iso27701: "ISO 27701",
            iso270012022annexacontrols: "ISO 27001:2022",
            iso270012022controls: "ISO 27001:2022",
            iso420012023controls: "ISO 42001",
            "nist800-53-rev5": "NIST 800-53 Rev 5",
            nist80053rev5: "NIST 800-53 Rev 5",
            pacontrols: "Privacy Act (PA)",
            soc2controls: "SOC 2",
            ism: "ISM",
            smb1001controls: "SMB 1001",
            smb1001: "SMB 1001",
            "qgov-is18": "QGOV IS18",
        };

        return standardMap[standard] || standard;
    }

    standardToAssuranceFrameName(standard) {
        const standardMap = {
            dispcontrols: "DISP",
            e8controls: "Essential 8",
            "iso 27701": "ISO 27701",
            iso27701: "ISO 27701",
            iso270012022annexacontrols: "ISO27001",
            iso270012022controls: "ISO27001",
            iso420012023controls: "ISO42001",
            pacontrols: "Privacy Act",
            soc2controls: "SOC2",
            ism: "ISM",
            smb1001controls: "SMB1001",
            "qgov-is18": "QGOV IS18",
            //smb1001: "SMB1001",
        };

        return standardMap[standard.toLowerCase()] || standard;
    }

    async fancyXLSXSheet(jsonData, saveAsFile = false) {
        let standardsList = [];
        if (jsonData === undefined || jsonData === null) return;

        // Initialize the workbook from the base64 string
        return this.XlsxPopulate.fromDataAsync(this.base64ToArrayBuffer(this.base64Excel)).then(async workbook => {
            const sheet = workbook.sheet(0); // Assuming the first sheet

            // Clear rows starting from row 9
            const startingRow = 9;
            const lastRow = sheet.usedRange().endCell().rowNumber();
            for (let i = startingRow; i <= lastRow; i++) {
                let rowNumber = i;
                let cells = sheet.row(rowNumber)._cells;
                for (let j = 1; j < cells.length; j++) {
                    sheet.row(rowNumber).cell(j).clear();
                }
            }

            let currentRow = startingRow;

            sheet.cell(`B3`).value(`${this.legalName} trading as ${this.friendlyName}`);
            sheet.cell(`B3`).style({
                "fill": "404040",
                "fontColor": "FFFFFF",
                "bold": true
            });

            let { version, lastUpdated } = await this.getSOAVersion(window.companyID);

            sheet.cell(`R3`).value(`Version ${version}, Last Updated ${lastUpdated}`);
            sheet.cell(`R3`).style({
                "fill": "404040",
                "fontColor": "FFD325",
                "bold": true
            });

            // Copy and paste row 7 for each clause manually
            const copyRowContent = (sourceRow, targetRow) => {
                const sourceCells = sourceRow._cells;
                let styles = null;
                sourceCells.forEach((cell, index) => {
                    const targetCell = sheet.row(targetRow).cell(index + 1);
                    targetCell.value(cell.value());

                    if (cell._style) {
                        styles = cell._style;
                        targetCell._style = cell._style;
                    } else {
                        if (styles !== null) {
                            targetCell._style = styles;
                        }
                    }
                });
            };

            for (const item of jsonData) {
                for (const clause of item.clauses) {
                    // Manually copy row 7 and paste it at the current row
                    copyRowContent(sheet.row(7), currentRow);

                    // Replace placeholders in the copied row (clause row)
                    sheet.cell(`C${currentRow}`).value(`${clause.rootNumber} - ${clause.clause}`);
                    sheet.cell(`C${currentRow}`).style({
                        "fill": "404040",
                        "fontColor": "FFFFFF",
                        "bold": true
                    });
                    sheet.row(currentRow).height(40);
                    currentRow++;

                    if (Array.isArray(clause.controls)) {
                        for (const control of clause.controls) {
                            let cleanName = await this.cleanStandardName(control.controlFramework) || await this.cleanStandardName(item.framework);
                            if (!standardsList.includes(cleanName)) {
                                standardsList.push(cleanName);
                            }

                            sheet.cell(`C${currentRow}`).value(control.controlName || '');
                            sheet.cell(`D${currentRow}`).value(control.controlNumber || '');
                            sheet.cell(`E${currentRow}`).value(cleanName || '');
                            sheet.cell(`F${currentRow}`).value(control.controlJustification.replace(/acme[\s,]*inc\.?/gi, this.tenancyName) || '');
                            sheet.cell(`G${currentRow}`).value(control.controlImplemented || '');
                            sheet.cell(`H${currentRow}`).value(control.count || 1);
                            sheet.cell(`K${currentRow}`).value(control.tasksCount || 0);
                            sheet.cell(`L${currentRow}`).value(control.policyCount || 0);
                            sheet.cell(`M${currentRow}`).value(control.docsCount || 0);
                            sheet.cell(`N${currentRow}`).value(control.risksCount || 0);
                            sheet.cell(`Q${currentRow}`).value(new this.XlsxPopulate.RichText())
                                .value().add((control.policies || []).map(policy => policy.policyName).join("\n"));
                            // console.error((Array.isArray(control.supportingDocs) ? control.supportingDocs : [] || []))
                            sheet.cell(`R${currentRow}`).value(new this.XlsxPopulate.RichText())
                                .value().add((Array.isArray(control.supportingDocs) ? control.supportingDocs : [] || []).join("\n"));

                            sheet.row(currentRow).height(40);

                            // Color styling based on controlImplemented value
                            const colorStyle = control.controlImplemented === 'No' ? 'C83232' : '000000';
                            ['C', 'D', 'E', 'F', 'G', 'H', 'K', 'L', 'M', 'N', 'Q', 'R'].forEach(col => {
                                sheet.cell(`${col}${currentRow}`).style({ 'fontColor': colorStyle, 'bold': false });
                            });
                            currentRow++;
                        }
                    } else {
                        console.warn('Item controls is not an array:', clause.controls);
                    }
                }
            }

            // Add the new "Clauses" sheet (only for ISO 27001:2022 Annex A)
            if (this.selectedFrameworks.includes('iso270012022annexacontrols') || this.selectedFrameworks.includes('iso420012023controls') || this.selectedFrameworks.includes('ISO27001') || this.selectedFrameworks.includes('ISO42001')) {
                console.log('Adding Clauses sheet...');
                let clauseData = await this.getClauseData(this.selectedFrameworks);
                console.log('Clause data:', clauseData);
                workbook = await this.addClausesSheet(workbook, clauseData);
            }
            // Add the new "Policy References" and "Supporting Docs" sheets
            workbook = await this.addPolicyReferenceSheet(workbook, jsonData);
            workbook = await this.addSupportingDocsReferenceSheet(workbook, jsonData);
            workbook = await this.addAssuranceTaskReferenceSheet(workbook, jsonData);
            workbook = await this.addMasterControlMappingSheet(workbook, jsonData);

            // Set the default active sheet to SOA Export (first sheet)
            workbook.activeSheet(0);

            return workbook.outputAsync().then(blob => {
                if (saveAsFile) {
                    // Save the file logic
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = `${this.tenancyName} - ${standardsList.join(', ')} - Auditor Export.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                } else {
                    // Return base64 string
                    return this.blobToBase64(blob);
                }
            }).catch(err => console.error("Error generating the workbook:", err));
        }).catch(err => console.error("Error loading the workbook:", err));
    }

    blobToBase64(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    async showCombinedModal() {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        const formattedDate = oneYearAgo.toISOString().split('T')[0];
        const { value: formValues } = await Swal.fire({
            title: 'Export Auditor Pack',
            html:
                `
                <h3>Audit Type</h3>
                <select id="typeOfAudit" class="swal2-select form-select" placeholder="Audit Type" style="width: 82%;">
                    <option value="" disabled selected>Select Audit Type</option>
                    <option value="Internal Audit">Internal Audit</option>
                    <option value="External Audit">External Audit</option>
                </select>
                <h3>Select Frameworks</h3>
                <div id="frameworkSelection" style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-evenly; gap: 6px; margin-bottom: 20px;">
                    <!---<button type="button" class="swal2-framework-btn btn btn-secondary" data-framework="all">All</button>--->
                    <button type="button" class="swal2-framework-btn btn btn-secondary" data-framework="dispcontrols">DISP</button>
                    <button type="button" class="swal2-framework-btn btn btn-secondary" data-framework="e8controls">Essential 8</button>
                    <button type="button" class="swal2-framework-btn btn btn-secondary" data-framework="iso27701">ISO 27701</button>
                    <button type="button" class="swal2-framework-btn btn btn-secondary" data-framework="iso270012022annexacontrols">ISO 27001:2022</button>
                    <button type="button" class="swal2-framework-btn btn btn-secondary" data-framework="qgov-is18">QGOV IS18</button>
                    <button type="button" class="swal2-framework-btn btn btn-secondary" data-framework="nist800-53-rev5">NIST 800-53 Rev 5</button>
                    <button type="button" class="swal2-framework-btn btn btn-secondary" data-framework="pacontrols">Privacy Act</button>
                    <button type="button" class="swal2-framework-btn btn btn-secondary" data-framework="soc2controls">SOC 2</button>
                    <button type="button" class="swal2-framework-btn btn btn-secondary" data-framework="ism">ISM</button>
                    <button type="button" class="swal2-framework-btn btn btn-secondary" data-framework="smb1001controls">SMB1001</button>
                </div>
                <h3>Select Date Range</h3>
                <input type="date" id="assuranceStartDate" value="${formattedDate}" class="swal2-input" placeholder="Start Date">
                <input type="date" id="assuranceEndDate" value="${new Date().toISOString().split('T')[0]}" class="swal2-input" placeholder="End Date">
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Export',
            cancelButtonText: 'Cancel',
            didOpen: () => {
                const frameworkButtons = document.querySelectorAll('.swal2-framework-btn');
                frameworkButtons.forEach(button => {
                    button.addEventListener('click', () => {
                        button.classList.toggle('btn-secondary');
                        button.classList.toggle('btn-primary'); // Toggle selection style
                    });
                });
            },
            preConfirm: () => {
                // Gather selected frameworks
                const selectedFrameworkButtons = document.querySelectorAll('.swal2-framework-btn.btn-primary');
                const selectedFrameworks = Array.from(selectedFrameworkButtons).map(button => button.getAttribute('data-framework'));

                // Gather assurance tasks date range
                const assuranceStartDate = document.getElementById('assuranceStartDate').value;
                const assuranceEndDate = document.getElementById('assuranceEndDate').value;

                // Gather ISMS corrective actions data
                const auditStartDate = document.getElementById('assuranceStartDate').value;
                const auditEndDate = document.getElementById('assuranceEndDate').value;
                const typeOfAudit = document.getElementById('typeOfAudit').value;
                // const riskRating = document.getElementById('riskRating').value;

                // Validation
                if (selectedFrameworks.length === 0) {
                    Swal.showValidationMessage('Please select at least one framework.');
                    return false;
                }

                if (!assuranceStartDate || !assuranceEndDate) {
                    Swal.showValidationMessage('Please select both start and end dates for assurance tasks.');
                    return false;
                }

                if (!auditStartDate || !auditEndDate || !typeOfAudit) {
                    Swal.showValidationMessage('Please fill in all ISMS Corrective Actions fields.');
                    return false;
                }

                if (new Date(assuranceStartDate) > new Date(assuranceEndDate)) {
                    Swal.showValidationMessage('Assurance Tasks: Start date cannot be after end date.');
                    return false;
                }

                if (new Date(auditStartDate) > new Date(auditEndDate)) {
                    Swal.showValidationMessage('ISMS Corrective Actions: Audit start date cannot be after end date.');
                    return false;
                }

                return {
                    selectedFrameworks,
                    assuranceDateRange: {
                        startDate: assuranceStartDate,
                        endDate: assuranceEndDate
                    },
                    ismsAuditData: {
                        toDate: auditStartDate,
                        fromDate: auditEndDate,
                        typeOfAudit
                    }
                };
            },
        });

        if (!formValues) {
            console.log('Export cancelled by the user.');
            return null;
        }

        return formValues;
    }

    // Ensure that JSZip is imported or available in your project
    // import JSZip from 'jszip'; // If using modules

    async exportNoUI(customerID = window.companyID, formValues, showLoading, onSuccess, onError) {
        try {
            if (!formValues) {
                // User cancelled the export
                console.log('Export cancelled by the user.');
                return;
            }

            const { selectedFrameworks, assuranceDateRange } = formValues;

            // Step 2: Indicate that the export process has started
            this.isExportingAuditorPack = true;

            if (showLoading) {
                showLoading(true);
            } else {
                // Fallback to Swal if no callback provided
                Swal.fire({
                    title: 'Exporting Auditor Pack...',
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading()
                });
            }

            // Check if user has any compliance modules enabled (ISO/SOC 2/NIST/ISM/RFFR)
            // Starter plan = no compliance modules enabled, should exclude SOA
            // Business/Enterprise = has compliance modules enabled, should include SOA
            const enabledModules = await getEnabledModules();
            const complianceModulePatterns = ['iso27001', 'soc2', 'nist', 'ism', 'rffr'];
            const hasComplianceModules = complianceModulePatterns.some(pattern => 
                Array.from(enabledModules).some(module => module.toLowerCase().includes(pattern))
            );
            const isStarterPlan = !hasComplianceModules;
            console.log('[AuditorExport] Enabled modules:', Array.from(enabledModules), 'Is Starter Plan:', isStarterPlan);

            let xlsxSheet = null;
            let isoControls = null;

            // Only generate SOA xlsx for non-Starter plans (plans with compliance modules)
            if (!isStarterPlan) {
                // Step 3: Execute parseISOControls with selected frameworks
                console.log('[AuditorExport] Selected frameworks:', selectedFrameworks);
                isoControls = await this.parseISOControls(customerID, Array.isArray(selectedFrameworks) ? selectedFrameworks : [selectedFrameworks]);

                if (!isoControls) {
                    throw new Error('Failed to parse ISO Controls.');
                }

                // Step 4: Generate Excel sheet from ISO Controls
                xlsxSheet = await this.fancyXLSXSheet(isoControls);

                if (!this.isExportingAuditorPack) {
                    console.warn('Export cancelled.');
                    return;
                }
            } else {
                console.log('[AuditorExport] Starter plan detected - skipping Statement of Applicability export');
            }

            // Step 5: Execute exportAssuranceTasksToWordDoc with date range
            const assuranceTasksDoc = await this.exportAssuranceTasksToWordDoc(customerID, assuranceDateRange);

            if (!assuranceTasksDoc) {
                throw new Error('Failed to export Assurance Tasks.');
            }

            // Step 6: Execute exportISMSCorrectiveActionsToWordDoc with audit data
            // const ismsCorrectiveActionsDoc = await this.exportISMSCorrectiveActionsToWordDoc('findings_and_corrective_actions.docx', ismsAuditData);

            // if (!ismsCorrectiveActionsDoc) {
            //     throw new Error('Failed to export ISMS Corrective Actions.');
            // }

            // Step 7: Package all documents into a ZIP file using JSZip
            const zip = new JSZip();
            const folderName = `${this.tenancyName} - Export`;
            const folder = zip.folder(folderName);

            if (!folder) {
                throw new Error('Failed to create ZIP folder.');
            }

            // Add Excel sheet only for non-Starter plans
            if (!isStarterPlan && xlsxSheet) {
                folder.file("Statement_of_Applicability.xlsx", xlsxSheet, { base64: true });
            }

            // Add Assurance Tasks Word document
            folder.file("Assurance_Tasks.docx", assuranceTasksDoc, { base64: true });

            // Add ISMS Corrective Actions Word document
            // folder.file("Findings_and_Corrective_Actions.docx", ismsCorrectiveActionsDoc, { base64: true });

            // Optional: Add additional files or folders as needed

            // Step 8: Generate the ZIP file as a Blob
            const zipBlob = await zip.generateAsync({ type: "blob", compression: "DEFLATE" });

            // Step 9: Trigger the download of the ZIP file
            const url = URL.createObjectURL(zipBlob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${this.tenancyName} - Auditor Export.zip`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url); // Clean up the URL object

            // Step 10: Notify the user of successful export
            if (onSuccess) {
                onSuccess();
            } else {
                Swal.fire('Success', 'Auditor Pack exported successfully!', 'success');
            }

            console.log('All export tasks completed successfully.');

            // Step 11: Reset the exporting flag
            this.isExportingAuditorPack = false;
        } catch (error) {
            console.error('Error during auditor pack export:', error);
            this.isExportingAuditorPack = false;

            // Notify the user of the error
            if (onError) {
                onError(error);
            } else {
                Swal.fire('Error', error.message, 'error');
            }
        } finally {
            // Hide loading
            if (showLoading) {
                showLoading(false);
            }
        }
    }

    async exportAuditorPack(customerID = window.companyID) {
        try {
            // Step 1: Show the combined modal and get user inputs
            const formValues = await this.showCombinedModal();

            if (!formValues) {
                // User cancelled the export
                console.log('Export cancelled by the user.');
                return;
            }

            const { selectedFrameworks, assuranceDateRange, ismsAuditData } = formValues;

            // Step 2: Indicate that the export process has started
            this.isExportingAuditorPack = true;

            // Optional: Show a loading indicator
            Swal.fire({
                title: 'Exporting Auditor Pack...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            // Check if user has any compliance modules enabled (ISO/SOC 2/NIST/ISM/RFFR)
            // Starter plan = no compliance modules enabled, should exclude SOA
            // Business/Enterprise = has compliance modules enabled, should include SOA
            const enabledModules = await getEnabledModules();
            const complianceModulePatterns = ['iso27001', 'soc2', 'nist', 'ism', 'rffr'];
            const hasComplianceModules = complianceModulePatterns.some(pattern => 
                Array.from(enabledModules).some(module => module.toLowerCase().includes(pattern))
            );
            const isStarterPlan = !hasComplianceModules;
            console.log('[AuditorExport] Enabled modules:', Array.from(enabledModules), 'Is Starter Plan:', isStarterPlan);

            let xlsxSheet = null;
            let isoControls = null;

            // Only generate SOA xlsx for non-Starter plans (plans with compliance modules)
            if (!isStarterPlan) {
                // Step 3: Execute parseISOControls with selected frameworks
                console.error('[AuditorExport] Selected frameworks:', selectedFrameworks);  
                console.error('[AuditorExport] Customer ID:', customerID);  
                isoControls = await this.parseISOControls(customerID, selectedFrameworks);

                if (!isoControls) {
                    throw new Error('Failed to parse ISO Controls.');
                }

                // Step 4: Generate Excel sheet from ISO Controls
                xlsxSheet = await this.fancyXLSXSheet(isoControls);

                if (!this.isExportingAuditorPack) {
                    console.warn('Export cancelled.');
                    return;
                }
            } else {
                console.log('[AuditorExport] Starter plan detected - skipping Statement of Applicability export');
            }

            // Step 5: Execute exportAssuranceTasksToWordDoc with date range
            const assuranceTasksDoc = await this.exportAssuranceTasksToWordDoc(customerID, assuranceDateRange);

            if (!assuranceTasksDoc) {
                throw new Error('Failed to export Assurance Tasks.');
            }

            // Step 6: Execute exportISMSCorrectiveActionsToWordDoc with audit data
            // const ismsCorrectiveActionsDoc = await this.exportISMSCorrectiveActionsToWordDoc('findings_and_corrective_actions.docx', ismsAuditData);

            // if (!ismsCorrectiveActionsDoc) {
            //     throw new Error('Failed to export ISMS Corrective Actions.');
            // }

            // Step 7: Package all documents into a ZIP file using JSZip
            const zip = new JSZip();
            const folderName = `${this.tenancyName} - Export`;
            const folder = zip.folder(folderName);

            if (!folder) {
                throw new Error('Failed to create ZIP folder.');
            }

            // Add Excel sheet only for non-Starter plans
            if (!isStarterPlan && xlsxSheet) {
                folder.file("Statement_of_Applicability.xlsx", xlsxSheet, { base64: true });
            }

            // Add Assurance Tasks Word document
            folder.file("Assurance_Tasks.docx", assuranceTasksDoc, { base64: true });

            // Add ISMS Corrective Actions Word document
            // folder.file("Findings_and_Corrective_Actions.docx", ismsCorrectiveActionsDoc, { base64: true });

            // Optional: Add additional files or folders as needed

            // Step 8: Generate the ZIP file as a Blob
            const zipBlob = await zip.generateAsync({ type: "blob", compression: "DEFLATE" });

            // Step 9: Trigger the download of the ZIP file
            const url = URL.createObjectURL(zipBlob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${this.tenancyName} - Auditor Export.zip`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url); // Clean up the URL object

            // Step 10: Notify the user of successful export
            Swal.fire('Success', 'Auditor Pack exported successfully!', 'success');

            console.log('All export tasks completed successfully.');

            // Step 11: Reset the exporting flag
            this.isExportingAuditorPack = false;
        } catch (error) {
            console.error('Error during auditor pack export:', error);
            this.isExportingAuditorPack = false;

            // Notify the user of the error
            Swal.fire('Error', error.message, 'error');
        }
    }

    async compileAuditorView() {
        this.isExportingAuditorPack = true;

        // Check if user has any compliance modules enabled (ISO/SOC 2/NIST/ISM/RFFR)
        // Starter plan = no compliance modules enabled, should exclude SOA
        // Business/Enterprise = has compliance modules enabled, should include SOA
        const enabledModules = await getEnabledModules();
        const complianceModulePatterns = ['iso27001', 'soc2', 'nist', 'ism', 'rffr'];
        const hasComplianceModules = complianceModulePatterns.some(pattern => 
            Array.from(enabledModules).some(module => module.toLowerCase().includes(pattern))
        );
        const isStarterPlan = !hasComplianceModules;
        console.log('[AuditorExport] Enabled modules:', Array.from(enabledModules), 'Is Starter Plan:', isStarterPlan);

        // Cancel out of below code if isExportingAuditorPack gets set to false at any point 

        let controls = null;
        let xlsxSheet = null;

        // Only generate SOA xlsx for non-Starter plans (plans with compliance modules)
        if (!isStarterPlan) {
            controls = await this.parseISOControls(window.companyID);

            if (!this.isExportingAuditorPack) {
                console.warn('Export cancelled');
                return;
            }

            xlsxSheet = await this.fancyXLSXSheet(controls);

            if (!this.isExportingAuditorPack) {
                console.warn('Export cancelled');
                return;
            }
        } else {
            console.log('[AuditorExport] Starter plan detected - skipping Statement of Applicability export');
        }

        let wordDoc = await this.exportAssuranceTasksToWordDoc(window.companyID);

        if (!this.isExportingAuditorPack) {
            console.warn('Export cancelled');
            return;
        }

        // let caWordDoc = await this.exportISMSCorrectiveActionsToWordDoc('findings_and_corrective_actions.docx');

        var zip = new this.JSZip();
        var folder = zip.folder(`${this.tenancyName} - Export`);
        
        // Add Excel sheet only for non-Starter plans
        if (!isStarterPlan && xlsxSheet) {
            await folder.file("statementOfApplicability.xlsx", xlsxSheet, { base64: true });
        }
        
        await folder.file("assuranceTasks.docx", wordDoc, { base64: true });
        // await folder.file("findings_and_corrective_actions.docx", caWordDoc, { base64: true });
        zip.generateAsync({ type: "blob", compression: "DEFLATE" })
            .then(function (content) {
                // see FileSaver.js
                const url = URL.createObjectURL(content);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${window.companyName} -  Auditor Export.zip`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                // saveAs(content, "AuditorView.zip");
            });
    }

    capitaliseFirstLetter(word) {
        if (!word) return ''; // Handle empty string case
        return word.charAt(0).toUpperCase() + word.slice(1);
    }

    getMajorityCheckStatus(checkHistory) {
        const statusCount = {};

        if (!checkHistory) return 'Incomplete';

        // Loop through checkHistory keys
        Object.keys(checkHistory).forEach(key => {
            const item = checkHistory[key];

            // Check if the checkStatus exists in the current item
            if (item.hasOwnProperty('checkStatus')) {
                const status = item.checkStatus;

                // Count occurrences of each checkStatus
                statusCount[status] = (statusCount[status] || 0) + 1;
            }
        });

        // Find the majority checkStatus
        let majorityStatus = 'Incomplete';
        let maxCount = 0;

        for (let status in statusCount) {
            if (statusCount[status] > maxCount) {
                maxCount = statusCount[status];
                majorityStatus = status;
            }
        }

        return this.capitaliseFirstLetter(majorityStatus);
    }

    getFileName(path) {
        // Split by both forward slash and backslash, and return the last part
        return path.split(/[\\/]/).pop();
    }

    getAllEvidences(checkHistory, startDate, endDate, basenameOnly = false) {
        let evidences = [];

        // Loop through each checkHistory item
        Object.values(checkHistory).forEach(item => {
            // If the item has an evidence field and it's an array, add to evidences
            let uploadDate = item.hasOwnProperty('performedDate') && item.performedDate instanceof FirebaseTimestamp ? item.performedDate.toDate().getTime() : item.hasOwnProperty('lastCheck') && item.lastCheck instanceof FirebaseTimestamp ? item.lastCheck.toDate().getTime() : null;

            if (uploadDate === null) return;

            // Check if uploadDate is within startDate and endDate
            const selectedStart = new Date(startDate);
            const selectedEnd = new Date(endDate);
            // Normalize dates to ignore time component
            selectedStart.setHours(0, 0, 0, 0);
            selectedEnd.setHours(23, 59, 59, 999);
            const taskDate = new Date(uploadDate);
            if (taskDate < selectedStart || taskDate > selectedEnd) {
                // Task's completedDate is outside the selected range
                return;
            }

            if (item.hasOwnProperty('evidence') && Array.isArray(item.evidence)) {
                if (basenameOnly) {
                    for (const evidence of item.evidence) {
                        evidences.push(this.getFileName(evidence));
                    }
                } else {
                    evidences.push(...item.evidence);
                }
            }
        });

        return evidences;
    }

    async exportAssuranceTasksToWordDoc(customerID, dateRange) {
        if (!this.isExportingAuditorPack) return;

        if (!dateRange || !dateRange?.startDate || !dateRange?.endDate) {
            console.log('No date range selected. Exporting latest history.');
            return;
        }

        // You can handle the selected dates here
        console.log('Start Date:', dateRange.startDate);
        console.log('End Date:', dateRange.endDate);
        console.log(`Selected Frameworks`, this.selectedFrameworks)
        // Fetch assurance tasks for the specified customerID
        const assuranceTasks = await this.getAssuranceTasks(customerID);

        // Filter and format the assurance tasks as a table
        const formattedAssuranceTasks = this.formatAssuranceTasks(assuranceTasks, dateRange.startDate, dateRange.endDate);

        const sortedTasks = formattedAssuranceTasks.sort((a, b) => {
            const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
            return collator.compare(a.taskID, b.taskID);
        });

        const controlData = await this.generateControlData.call(this, sortedTasks);
        console.log('Control Data generated', controlData);

        // Process each task to include images and hyperlinks
        const tasksWithEvidence = await Promise.all(sortedTasks.map(async (task) => {
            const evidenceData = await Promise.all(task.SupportingDocs.map(async (filePath) => {
                const fileType = this.getFileType(filePath);
                const fileName = this.getFileName(filePath);
                const fileUrl = await downloadFromSDK(firebaseConfig, storageRef, 'pdf', null, filePath, filePath, false);
                console.log('File URL:', fileUrl);
                if (!fileUrl || fileUrl === '') return;
                if (fileType === 'image') {
                    // For images, get the base64 data
                    const response = await fetch(fileUrl);
                    const blob = await response.blob();
                    const base64Image = await convertBlobToBase64(blob);
                    return {
                        type: 'image',
                        isImage: true,
                        isLink: false,
                        name: fileName,
                        data: base64Image
                    };
                } else if (fileType === 'pdf') {
                    // Optionally convert PDF to image (requires additional library)
                    // For now, we'll treat PDFs as hyperlinks
                    return {
                        type: 'link',
                        isImage: false,
                        isLink: true,
                        linkText: fileName,
                        linkHref: fileUrl
                    };
                } else {
                    // For non-image files, prepare the hyperlink
                    return {
                        type: 'link',
                        isImage: false,
                        isLink: true,
                        linkText: fileName,
                        linkHref: fileUrl
                    };
                }
            }));

            return {
                ...task,
                evidenceData: evidenceData
            };
        }));


        let templateData = {
            CompanyFriendlyName: this.friendlyName,
            CompanyLegalName: this.legalName,
            ...controlData,
            assuranceTasks: tasksWithEvidence,
        }

        console.log('Template Data', templateData);

        // Export the formatted assurance tasks to a word document
        // return this.exportTasksToWordDocument(formattedAssuranceTasks, 'assuranceTasks.docx');
        return (await convertBlobToBase64(await generateAssuranceDoc(templateData))).split(',')[1];
    }

    async getAssuranceTasks(customerID = window.companyID) {
        // Fetch assurance tasks for the specified customerID
        return db.doc(`customers/${customerID}/compliance/assurance`).get()
            .then(snapshot => snapshot.data())
            .catch(error => console.error(error));
    }

    formatAssuranceTasks(tasks, startDate, endDate) {
        console.log(tasks, typeof tasks);
        const formattedTasks = Object.keys(tasks).map(taskID => {
            let controlIDs = [];

            let task = tasks[taskID];

            console.log(task, taskID);
            if (!task.hasOwnProperty('checkDetail')) return;

            // Check if task.checkDetail.active is a string or boolean and if it is not set to true, skip to next task
            if (task.checkDetail.active === false || (typeof task.checkDetail.active === 'string' && task.checkDetail.active.toLowerCase() === 'false')) {
                return;
            }

            // Replace any occurence of acme inc (any capitalisation or punctuation) with the company name
            task.checkDetail.check = task.checkDetail.check.replace(/acme inc/gi, this.friendlyName);

            let matchedFrameworks = [];
            if (Array.isArray(this.selectedFrameworks) && this.selectedFrameworks.length > 0) {
                console.log('[AuditorExport] Checking frameworks for task:', taskID, this.selectedFrameworks, task.checkDetail.framework);
                // Check that selectedFrameworks includes at least one of the task frameworks
                for (let i = 0; i < Object.keys(task.checkDetail.framework).length; i++) {
                    let framework = this.standardToAssuranceFrameName(task.checkDetail.framework[i].frameName);
                    console.log('[AuditorExport] Checking framework:', framework, task.checkDetail.framework[i].frameName, this.selectedFrameworks, this.selectedFrameworks.includes(framework), matchedFrameworks);
                    if (this.selectedFrameworks.includes(framework)) {
                        matchedFrameworks.push(framework);
                    }
                }

                if (matchedFrameworks.length === 0) {
                    console.log(`Skipping task ${taskID} as it does not match any selected frameworks.`, this.selectedFrameworks, task.checkDetail.framework);
                    return;
                }
            }

            // let comments = "";

            const completedDate = typeof task?.checkFrequency?.lastCheck === 'object' && this.getMajorityCheckStatus(task.checkHistory) === "Complete"
                ? (() => {
                    // Helper function to check if a date is valid
                    const isValidDate = (date) => date instanceof Date && !isNaN(date.getTime());

                    let validDates = [];

                    // **Process `lastCheck` Entries**
                    const lastCheckEntries = Object.values(task.checkFrequency.lastCheck);
                    const lastCheckDates = lastCheckEntries.map(item => {
                        try {
                            // Check if item.checkDate is a Firebase Timestamp
                            if (item.checkDate && item.checkDate instanceof FirebaseTimestamp) {
                                const date = item.checkDate.toDate();
                                if (isValidDate(date)) {
                                    return date.getTime();
                                } else {
                                    console.info('Invalid or incomplete checkDate in lastCheck:', date, item);
                                    return NaN; // Invalid date or incomplete status
                                }
                            } else {
                                console.info('No valid checkDate in lastCheck:', item.checkDate, item);
                                return NaN; // Not a valid checkDate
                            }
                        } catch (error) {
                            console.error('Error processing checkDate in lastCheck:', item.checkDate, error, item);
                            return NaN; // Error in processing
                        }
                    }).filter(time => !isNaN(time)); // Filter out invalid timestamps

                    validDates = validDates.concat(lastCheckDates);

                    // **Process `checkHistory` Entries**
                    if (task.checkHistory && typeof task.checkHistory === 'object') {
                        const checkHistoryEntries = Object.values(task.checkHistory);
                        const checkHistoryDates = checkHistoryEntries.map(item => {
                            try {
                                // Check if item.checkDate is a Firebase Timestamp and checkStatus is 'complete'
                                if (item.performedDate && item.performedDate instanceof FirebaseTimestamp && item.checkStatus === 'complete') {
                                    const date = item.performedDate.toDate();
                                    if (isValidDate(date)) {
                                        return date.getTime();
                                    } else {
                                        console.info('Invalid performedDate in checkHistory:', date, item);
                                        return NaN; // Invalid date
                                    }
                                } else {
                                    // Either no checkDate, not a FirebaseTimestamp, or not complete
                                    return NaN;
                                }
                            } catch (error) {
                                console.error('Error processing performedDate in checkHistory:', item.performedDate, error, item);
                                return NaN; // Error in processing
                            }
                        }).filter(time => !isNaN(time)); // Filter out invalid timestamps

                        validDates = validDates.concat(checkHistoryDates);
                    }

                    // If there are valid dates, get the most recent one; otherwise, return null
                    if (validDates.length > 0) {
                        const latestTime = Math.max(...validDates);
                        return new Date(latestTime);
                    } else {
                        return null;
                    }
                })()
                : null;

            const comments = typeof task?.checkFrequency?.lastCheck === 'object' && this.getMajorityCheckStatus(task.checkHistory) === "Complete"
                ? (() => {
                    // Helper function to check if a date is valid
                    const isValidDate = (date) => date instanceof Date && !isNaN(date.getTime());

                    let latestComments = "";

                    // **Process `checkHistory` Entries**
                    if (task.checkHistory && typeof task.checkHistory === 'object') {
                        const checkHistoryEntries = Object.values(task.checkHistory);
                        const checkHistoryProcessed = checkHistoryEntries
                            .filter(item =>
                                item.performedDate &&
                                item.performedDate instanceof FirebaseTimestamp &&
                                item.checkStatus === 'complete'
                            )
                            .map(item => {
                                try {
                                    const date = item.performedDate.toDate();
                                    if (isValidDate(date)) {
                                        console.log('Comments', item.comments)
                                        return {
                                            time: date.getTime(),
                                            comments: item.comments || "" // Assuming 'comments' field exists
                                        };
                                    } else {
                                        console.info('Invalid performedDate in checkHistory:', date, item);
                                        return null; // Invalid date
                                    }
                                } catch (error) {
                                    console.error('Error processing performedDate in checkHistory:', item.performedDate, error, item);
                                    return null; // Error in processing
                                }
                            })
                            .filter(entry => entry !== null); // Filter out invalid entries

                        if (checkHistoryProcessed.length > 0) {
                            // Determine the latest checkHistory entry
                            const latestEntry = checkHistoryProcessed.reduce((prev, current) =>
                                current.time > prev.time ? current : prev
                            );

                            latestComments = latestEntry.comments;
                        }
                    }

                    return latestComments;
                })()
                : "";

            const performedBy = typeof task?.checkFrequency?.lastCheck === 'object' && this.getMajorityCheckStatus(task.checkHistory) === "Complete"
                ? (() => {
                    // Helper function to check if a date is valid
                    const isValidDate = (date) => date instanceof Date && !isNaN(date.getTime());

                    let latestPerformance = "";

                    // **Process `checkHistory` Entries**
                    if (task.checkHistory && typeof task.checkHistory === 'object') {
                        const checkHistoryEntries = Object.values(task.checkHistory);
                        const checkHistoryProcessed = checkHistoryEntries
                            .filter(item =>
                                item.performedDate &&
                                item.performedDate instanceof FirebaseTimestamp &&
                                item.checkStatus === 'complete'
                            )
                            .map(item => {
                                try {
                                    const date = item.performedDate.toDate();
                                    if (isValidDate(date)) {
                                        console.log('Comments', item.performedBy)
                                        return {
                                            time: date.getTime(),
                                            performedBy: item.performedBy || "" // Assuming 'comments' field exists
                                        };
                                    } else {
                                        console.info('Invalid performedDate in checkHistory:', date, item);
                                        return null; // Invalid date
                                    }
                                } catch (error) {
                                    console.error('Error processing performedDate in checkHistory:', item.performedDate, error, item);
                                    return null; // Error in processing
                                }
                            })
                            .filter(entry => entry !== null); // Filter out invalid entries

                        if (checkHistoryProcessed.length > 0) {
                            // Determine the latest checkHistory entry
                            const latestEntry = checkHistoryProcessed.reduce((prev, current) =>
                                current.time > prev.time ? current : prev
                            );

                            latestPerformance = latestEntry.performedBy;
                        }
                    }

                    return latestPerformance;
                })()
                : "";

            // If completedDate is not within the selected range, skip this task
            if (completedDate) {
                const selectedStart = new Date(startDate);
                const selectedEnd = new Date(endDate);
                // Normalize dates to ignore time component
                selectedStart.setHours(0, 0, 0, 0);
                selectedEnd.setHours(23, 59, 59, 999);
                const taskDate = new Date(completedDate);
                if (taskDate < selectedStart || taskDate > selectedEnd) {
                    console.log('[AuditorExport] Task outside selected range', taskID, taskDate, selectedStart, selectedEnd);
                    // Task's completedDate is outside the selected range
                    return;
                }
            } else {
                console.log('[AuditorExport] Task has no completedDate', taskID);
                // If there's no completedDate, decide whether to include or exclude the task
                // For this example, we'll exclude tasks without a completedDate
                return;
            }

            const formattedTask = {
                taskID: task.assID,
                controlIDs: [...(task.checkDetail.procRef || [])/*, ...(task.checkDetail.procRef2013 || [])*/],
                description: task?.checkDetail?.check || 'No Check',
                completedDate: completedDate ? completedDate.toISOString().split('T')[0] : 'No Date',
                completedBy: nameFromUID(performedBy || task?.checkDetail?.assignedTo || 'Unassigned'),
                assignedTo: nameFromUID(task?.checkDetail?.assignedTo || 'Unassigned'),
                evidence: this.getAllEvidences(task.checkHistory, startDate, endDate, true) || 'No Evidence Provided',
                SupportingDocs: this.getAllEvidences(task.checkHistory, startDate, endDate, false) || 'No Evidence Provided',
                isComplete: this.getMajorityCheckStatus(task.checkHistory),
                comments: comments || 'No Comments Provided',
                framework: task?.checkDetail?.framework[0].frameName || 'No Framework',
            };
            return formattedTask;
        })
            .filter(task => task !== undefined && task !== null); // Remove undefined or null entries

        return formattedTasks;
    }

    getFileType(fileName) {
        // Extract the file extension from the file name
        const extension = fileName.split('.').pop().toLowerCase();

        // Map file extensions to file types
        const fileTypeMap = {
            pdf: 'pdf',
            png: 'image',
            jpg: 'image',
            jpeg: 'image',
            gif: 'image',
            bmp: 'image',
            csv: 'csv',
            xlsx: 'spreadsheet',
            xls: 'spreadsheet',
            doc: 'document',
            docx: 'document',
            zip: 'archive',
            rar: 'archive',
            tar: 'archive',
            gz: 'archive',
            // Add more mappings as needed
        };

        // Return the file type based on the extension or a default type
        return fileTypeMap[extension] || 'unknown';
    }

    async generateControlData(tasks) {
        // Ensure compliance cache is loaded
        if (!this.complianceCache || Object.keys(this.complianceCache).length === 0) {
            await this.loadComplianceCache();
        }

        const result = {
            standardsImplemented: [],
            controls: []
        };

        const controlsMap = new Map(); // controlID -> {controlID, controlName, controlFramework, tasks}
        const frameworksMap = new Map(); // controlFramework -> Set of controlIDs

        for (const task of tasks) {
            if (!task || !Array.isArray(task.controlIDs)) continue;

            for (const controlID of task.controlIDs) {
                // Get control data using your method
                const controlData = await this.checkGlobalSOA(controlID);

                if (!controlData || Object.keys(controlData).length === 0) {
                    console.warn(`Control data not found for controlID: ${controlID}`);
                    continue;
                }

                // Extract controlName and controlFramework
                const controlName =
                    controlData.controlName ||
                    controlData.controlTitle ||
                    controlData.controlJustification ||
                    'Unknown Control Name';
                let controlFramework = controlData.controlFramework || 'Unknown Framework';

                // Update controlsMap
                if (!controlsMap.has(controlID)) {
                    controlsMap.set(controlID, {
                        controlID: controlID,
                        controlName: controlName,
                        controlFramework: controlFramework,
                        tasks: 1
                    });
                } else {
                    const controlEntry = controlsMap.get(controlID);
                    controlEntry.tasks += 1;
                }

                // Update frameworksMap
                const framework = controlFramework;
                if (!frameworksMap.has(framework)) {
                    frameworksMap.set(framework, new Set());
                }
                frameworksMap.get(framework).add(controlID);
            }
        }

        // Convert controlsMap to array
        result.controls = Array.from(controlsMap.values());

        // Sorting the controls array by controlID with enhanced comparator
        result.controls.sort(this.compareControlIDs);

        // Convert frameworksMap to standardsImplemented array
        result.standardsImplemented = Array.from(frameworksMap.entries()).map(async ([framework, controlIDsSet]) => {
            return {
                framework: framework,
                controlsImplemented: controlIDsSet.size
            };
        });

        console.log('[AuditorExport] Generated control data:', result);

        return result;
    }

    /**
     * Comparator function to sort controlIDs considering alphanumeric segments and wildcards.
     * @param {Object} a - First control object with controlID.
     * @param {Object} b - Second control object with controlID.
     * @returns {number} - Sorting order indicator.
     */
    compareControlIDs = (a, b) => {
        const aSegments = a.controlID.split('.');
        const bSegments = b.controlID.split('.');

        const maxLength = Math.max(aSegments.length, bSegments.length);

        for (let i = 0; i < maxLength; i++) {
            const aSeg = aSegments[i] || '';
            const bSeg = bSegments[i] || '';

            // Handle wildcards: assume '*' is greater than any alphanumeric segment
            if (aSeg === '*' && bSeg !== '*') return 1;
            if (bSeg === '*' && aSeg !== '*') return -1;
            if (aSeg === '*' && bSeg === '*') continue; // Both wildcards, move to next segment

            // Tokenize segments into numbers and strings
            const aTokens = this.tokenize(aSeg);
            const bTokens = this.tokenize(bSeg);

            const tokenMaxLength = Math.max(aTokens.length, bTokens.length);

            for (let j = 0; j < tokenMaxLength; j++) {
                const aToken = aTokens[j];
                const bToken = bTokens[j];

                // If one segment has more tokens, it's considered greater
                if (aToken === undefined && bToken !== undefined) return -1;
                if (bToken === undefined && aToken !== undefined) return 1;
                if (aToken === undefined && bToken === undefined) continue;

                // Compare tokens
                if (typeof aToken === 'number' && typeof bToken === 'number') {
                    if (aToken < bToken) return -1;
                    if (aToken > bToken) return 1;
                } else if (typeof aToken === 'string' && typeof bToken === 'string') {
                    const aLower = aToken.toLowerCase();
                    const bLower = bToken.toLowerCase();
                    if (aLower < bLower) return -1;
                    if (aLower > bLower) return 1;
                } else if (typeof aToken === 'number' && typeof bToken === 'string') {
                    // Numbers come before strings
                    return -1;
                } else if (typeof aToken === 'string' && typeof bToken === 'number') {
                    return 1;
                }
            }
        }

        return 0; // controlIDs are equal
    }

    /**
     * Tokenizes a segment into an array of numbers and strings.
     * E.g., "1a2B" => [1, 'a', 2, 'B']
     * @param {string} segment - The segment string to tokenize.
     * @returns {Array<number|string>} - Array of tokens.
     */
    tokenize = (segment) => {
        const tokens = [];
        let currentToken = '';
        let isNumber = null;

        for (let char of segment) {
            if (/\d/.test(char)) {
                if (isNumber === true || isNumber === null) {
                    currentToken += char;
                    isNumber = true;
                } else {
                    if (currentToken.length > 0) {
                        tokens.push(currentToken);
                    }
                    currentToken = char;
                    isNumber = true;
                }
            } else {
                if (isNumber === false || isNumber === null) {
                    currentToken += char;
                    isNumber = false;
                } else {
                    if (currentToken.length > 0) {
                        tokens.push(parseInt(currentToken, 10));
                    }
                    currentToken = char;
                    isNumber = false;
                }
            }
        }

        if (currentToken.length > 0) {
            if (isNumber) {
                tokens.push(parseInt(currentToken, 10));
            } else {
                tokens.push(currentToken);
            }
        }

        return tokens;
    }

    // // Additional methods like exportISMSCorrectiveActionsToWordDoc would go here
    // exportISMSCorrectiveActionsToWordDoc = async (filename, auditData, saveToFile = false) => {
    //     const ismsRegisterArray = [];
    //     const { toDate, fromDate, typeOfAudit } = auditData;

    //     if (!toDate || !fromDate || !typeOfAudit) {
    //         console.warn('Missing audit data. Export cancelled.');
    //         return;
    //     }

    //     // let toDate = null;
    //     // let fromDate = null;
    //     // let typeOfAudit = '';
    //     // let riskRating = 0;

    //     //     await Swal.fire({
    //     //         title: 'Select Audit Date Range & Type for ISMS Register Export',
    //     //         html:
    //     //             `<input type="date" id="startDate" class="swal2-input" placeholder="Audit Start Date">
    //     //    <input type="date" id="endDate" class="swal2-input" placeholder="Audit End Date">
    //     //    <select id="typeOfAudit" class="swal2-select" placeholder="Audit Type">
    //     //       <option value="" disabled selected>Select Audit Type</option>
    //     //       <option value="Internal audit">Internal audit</option>
    //     //       <option value="Stage 1 audit">Stage 1 audit</option>
    //     //       <option value="Stage 2 audit">Stage 2 audit</option>
    //     //       <option value="Surveillance audit">Surveillance audit</option>
    //     //    </select>
    //     //    <input type="number" id="riskRating" class="swal2-input" placeholder="Risk rating">`,
    //     //         focusConfirm: false,
    //     //         showCancelButton: true,
    //     //         preConfirm: () => {
    //     //             toDate = document.getElementById('startDate').valueAsDate;
    //     //             fromDate = document.getElementById('endDate').valueAsDate;
    //     //             typeOfAudit = document.getElementById('typeOfAudit').value;
    //     //             riskRating = document.getElementById('riskRating').value;

    //     //             if (!toDate || !fromDate || !typeOfAudit || !riskRating) {
    //     //                 Swal.showValidationMessage('Please fill in all fields');
    //     //                 return false;
    //     //             }

    //     //             // Optional: Add more validation (fromDate.g., startDate <= endDate)
    //     //             if (new Date(toDate) > new Date(fromDate)) {
    //     //                 Swal.showValidationMessage('Start date cannot be after end date');
    //     //                 return false;
    //     //             }

    //     //             return { toDate, fromDate, typeOfAudit, riskRating };
    //     //         },
    //     //     }).then((result) => {
    //     //         console.log(result)
    //     //         if (!result.isConfirmed) {
    //     //             console.log('Cancelling')
    //     //             this.isExportingAuditorPack = false;
    //     //         }
    //     //     });

    //     if (!this.isExportingAuditorPack) {
    //         console.warn('Export cancelled');
    //         return;
    //     }

    //     const customerDoc = await db.collection('customers').doc(companyID).get();
    //     const issmsRegisterCollection = await db.collection("customers").doc(window.companyID).collection("compliance").doc("ismsRegister").collection("register").get();

    //     for (const ismsRegisterItem of issmsRegisterCollection.docs) {
    //         const data = await ismsRegisterItem?.data();
    //         console.log(data)
    //         const arrayItem = {
    //             ...data,
    //             reportedOn: await data.reportedOn.toDate(),
    //             completedOn: await data.completedOn?.toDate() ?? null
    //         };
    //         console.log(arrayItem)
    //         ismsRegisterArray.push(arrayItem);
    //     }

    //     if (!this.isExportingAuditorPack) {
    //         console.warn('Export cancelled');
    //         return;
    //     }

    //     console.log(ismsRegisterArray)

    //     const ismsRegisterItems = ismsRegisterArray.sort((a, b) => ((a.id ?? 0) > (b.id ?? 0) ? 1 : ((b.id ?? 0) > (a.id ?? 0) ? -1 : 0))).filter((a) => a.entryType === "Finding").filter((a) => a.reportedOn.getTime() >= new Date(toDate).getTime() && a.reportedOn.getTime() <= new Date(fromDate).getTime());
    //     const correctiveActionsArray = [];
    //     for (const ismsRegisterItem of ismsRegisterItems) {
    //         const correctiveActions = await ismsRegisterItem?.correctiveActions;
    //         const correctiveActionKeys = Object.keys(correctiveActions);
    //         console.log(correctiveActions)
    //         for (const correctiveActionID of correctiveActionKeys) {
    //             const correctiveAction = correctiveActions[correctiveActionID];
    //             let caAssignee = '';
    //             for (const assignee of window.assignees) {
    //                 if (assignee?.userID === correctiveAction.caOwner || assignee?.mspUsers?.includes(correctiveAction.caOwner)) {
    //                     if (assignee.mspUser === true) {
    //                         caAssignee = `${assignee.companyName}`;
    //                     } else {
    //                         caAssignee = `${assignee.firstName} ${assignee.lastName}`;
    //                     }
    //                 }
    //             }
    //             correctiveActionsArray.push({
    //                 FINDING: ismsRegisterItem.summary,
    //                 CONTROL_IDS_AFFECTED: ismsRegisterItem.controls,
    //                 ISSUE_SUMMARY: ismsRegisterItem.summary,
    //                 CORRECTIVE_ACTION_PLAN: correctiveAction.caCorrectiveSteps,
    //                 COMPLETED_DATE: "Due on: " + correctiveAction.caDueDate.toDate().toLocaleDateString(),
    //                 PERSON_RESPONSIBLE: caAssignee,
    //                 CA_ID: correctiveAction.caID,
    //                 ENTRY_ID: "Entry " + ismsRegisterItem.id.toString() + " - ",
    //             })
    //         }
    //     }

    //     if (!this.isExportingAuditorPack) {
    //         console.warn('Export cancelled');
    //         return;
    //     }

    //     const logoLink = await downloadFromSDK(
    //         firebaseConfig,
    //         storageRef,
    //         'pdf',
    //         null,
    //         companyID + '_logo.png',
    //         'companyLogos/' + companyID + '/' + companyID + '_logo.png',
    //     ) ?? `${window.location.origin}/favicon/favicon-16x16.png`;

    //     console.log(logoLink)

    //     const options = {
    //         companyName: await customerDoc.data().customerFriendlyName,
    //         documentControlDate: new Date().toLocaleDateString(), // Provide the document control date
    //         typeOfAudit: typeOfAudit,
    //         fromDate: new Date(fromDate).toLocaleDateString(),
    //         toDate: new Date(toDate).toLocaleDateString(),
    //         countOfFindings: correctiveActionsArray.length + 1,
    //         correctiveActions: correctiveActionsArray,
    //         logo: logoLink
    //     };

    //     console.log(correctiveActionsArray)
    //     console.log(options)

    //     if (!this.isExportingAuditorPack) {
    //         console.warn('Export cancelled');
    //         return;
    //     }

    //     return (await convertBlobToBase64(await generateDocument(options))).split(',')[1];
    // }

    // Helper methods like downloadFromSDK, convertBlobToBase64, etc., should also be implemented

    // Ensure all functions from your original code are converted into methods and included here

    isISMSelected(selectedFrameworks) {
        return selectedFrameworks.includes('ism') || selectedFrameworks.includes('all');
    }
}